// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSetupRouteImport } from './routes/_authenticated/setup'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedScoreboardRouteImport } from './routes/_authenticated/scoreboard'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as AuthenticatedAppRouteImport } from './routes/_authenticated/app'
import { Route as AuthenticatedPortalWorkspaceRouteImport } from './routes/_authenticated/portal/workspace'
import { Route as AuthenticatedPortalSlaRouteImport } from './routes/_authenticated/portal/sla'
import { Route as AuthenticatedPortalSettingsRouteImport } from './routes/_authenticated/portal/settings'
import { Route as AuthenticatedPortalRmasRouteImport } from './routes/_authenticated/portal/rmas'
import { Route as AuthenticatedPortalReportsRouteImport } from './routes/_authenticated/portal/reports'
import { Route as AuthenticatedPortalProfitabilityRouteImport } from './routes/_authenticated/portal/profitability'
import { Route as AuthenticatedPortalOrdersRouteImport } from './routes/_authenticated/portal/orders'
import { Route as AuthenticatedPortalInvoicesRouteImport } from './routes/_authenticated/portal/invoices'
import { Route as AuthenticatedPortalInventoryRouteImport } from './routes/_authenticated/portal/inventory'
import { Route as AuthenticatedPortalInboundRouteImport } from './routes/_authenticated/portal/inbound'
import { Route as AuthenticatedPortalDashboardRouteImport } from './routes/_authenticated/portal/dashboard'
import { Route as AuthenticatedPortalCreditsRouteImport } from './routes/_authenticated/portal/credits'
import { Route as AuthenticatedPortalChatRouteImport } from './routes/_authenticated/portal/chat'
import { Route as AuthenticatedAppYardRouteImport } from './routes/_authenticated/app/yard'
import { Route as AuthenticatedAppWarehouseMapRouteImport } from './routes/_authenticated/app/warehouse-map'
import { Route as AuthenticatedAppTransfersRouteImport } from './routes/_authenticated/app/transfers'
import { Route as AuthenticatedAppTasksRouteImport } from './routes/_authenticated/app/tasks'
import { Route as AuthenticatedAppSuppliersRouteImport } from './routes/_authenticated/app/suppliers'
import { Route as AuthenticatedAppSlottingRouteImport } from './routes/_authenticated/app/slotting'
import { Route as AuthenticatedAppShipmentsRouteImport } from './routes/_authenticated/app/shipments'
import { Route as AuthenticatedAppScanRouteImport } from './routes/_authenticated/app/scan'
import { Route as AuthenticatedAppRfRouteImport } from './routes/_authenticated/app/rf'
import { Route as AuthenticatedAppReturnsRulesRouteImport } from './routes/_authenticated/app/returns-rules'
import { Route as AuthenticatedAppReturnsRefurbRouteImport } from './routes/_authenticated/app/returns-refurb'
import { Route as AuthenticatedAppReturnsReceivingRouteImport } from './routes/_authenticated/app/returns-receiving'
import { Route as AuthenticatedAppReturnsDispositionRouteImport } from './routes/_authenticated/app/returns-disposition'
import { Route as AuthenticatedAppReturnsCreditsRouteImport } from './routes/_authenticated/app/returns-credits'
import { Route as AuthenticatedAppReturnsRouteImport } from './routes/_authenticated/app/returns'
import { Route as AuthenticatedAppReportsRouteImport } from './routes/_authenticated/app/reports'
import { Route as AuthenticatedAppReceivingRouteImport } from './routes/_authenticated/app/receiving'
import { Route as AuthenticatedAppQualityIntelligenceRouteImport } from './routes/_authenticated/app/quality-intelligence'
import { Route as AuthenticatedAppPutawayRouteImport } from './routes/_authenticated/app/putaway'
import { Route as AuthenticatedAppPoliciesRouteImport } from './routes/_authenticated/app/policies'
import { Route as AuthenticatedAppPlaybookRouteImport } from './routes/_authenticated/app/playbook'
import { Route as AuthenticatedAppPickRouteImport } from './routes/_authenticated/app/pick'
import { Route as AuthenticatedAppOrdersRouteImport } from './routes/_authenticated/app/orders'
import { Route as AuthenticatedAppOperationsRouteImport } from './routes/_authenticated/app/operations'
import { Route as AuthenticatedAppOnboardingRouteImport } from './routes/_authenticated/app/onboarding'
import { Route as AuthenticatedAppLaborRouteImport } from './routes/_authenticated/app/labor'
import { Route as AuthenticatedAppLabelsRouteImport } from './routes/_authenticated/app/labels'
import { Route as AuthenticatedAppInventoryRouteImport } from './routes/_authenticated/app/inventory'
import { Route as AuthenticatedAppImportsRouteImport } from './routes/_authenticated/app/imports'
import { Route as AuthenticatedAppImplementationRouteImport } from './routes/_authenticated/app/implementation'
import { Route as AuthenticatedAppForecastingRouteImport } from './routes/_authenticated/app/forecasting'
import { Route as AuthenticatedAppExceptionsRouteImport } from './routes/_authenticated/app/exceptions'
import { Route as AuthenticatedAppDockRouteImport } from './routes/_authenticated/app/dock'
import { Route as AuthenticatedAppDashboardRouteImport } from './routes/_authenticated/app/dashboard'
import { Route as AuthenticatedAppCycleCountsRouteImport } from './routes/_authenticated/app/cycle-counts'
import { Route as AuthenticatedAppComplianceRouteImport } from './routes/_authenticated/app/compliance'
import { Route as AuthenticatedAppChatRouteImport } from './routes/_authenticated/app/chat'
import { Route as AuthenticatedAppAdminRouteImport } from './routes/_authenticated/app/admin'
import { Route as AuthenticatedPortalRmasRmaIdRouteImport } from './routes/_authenticated/portal/rmas.$rmaId'
import { Route as AuthenticatedPortalReportsIndexRouteImport } from './routes/_authenticated/portal/reports.index'
import { Route as AuthenticatedPortalReportsSubscriptionsRouteImport } from './routes/_authenticated/portal/reports.subscriptions'
import { Route as AuthenticatedPortalReportsHistoryRouteImport } from './routes/_authenticated/portal/reports.history'
import { Route as AuthenticatedPortalReportsReportKeyRouteImport } from './routes/_authenticated/portal/reports.$reportKey'
import { Route as AuthenticatedPortalOrdersNewRouteImport } from './routes/_authenticated/portal/orders.new'
import { Route as AuthenticatedPortalOrdersOrderIdRouteImport } from './routes/_authenticated/portal/orders.$orderId'
import { Route as AuthenticatedPortalInboundAsnIdRouteImport } from './routes/_authenticated/portal/inbound.$asnId'
import { Route as AuthenticatedAppPackIndexRouteImport } from './routes/_authenticated/app/pack/index'
import { Route as AuthenticatedAppManifestsIndexRouteImport } from './routes/_authenticated/app/manifests.index'
import { Route as AuthenticatedAppBolsIndexRouteImport } from './routes/_authenticated/app/bols.index'
import { Route as AuthenticatedAppBillingIndexRouteImport } from './routes/_authenticated/app/billing.index'
import { Route as AuthenticatedAppTraceabilityRefRouteImport } from './routes/_authenticated/app/traceability.$ref'
import { Route as AuthenticatedAppTraceCaptureRouteImport } from './routes/_authenticated/app/trace.capture'
import { Route as AuthenticatedAppSettingsWebhooksRouteImport } from './routes/_authenticated/app/settings.webhooks'
import { Route as AuthenticatedAppSettingsStatusSubscribersRouteImport } from './routes/_authenticated/app/settings.status-subscribers'
import { Route as AuthenticatedAppSettingsStatusRouteImport } from './routes/_authenticated/app/settings.status'
import { Route as AuthenticatedAppSettingsSsoRouteImport } from './routes/_authenticated/app/settings.sso'
import { Route as AuthenticatedAppSettingsShipmentIssuesRouteImport } from './routes/_authenticated/app/settings.shipment-issues'
import { Route as AuthenticatedAppSettingsScimRouteImport } from './routes/_authenticated/app/settings.scim'
import { Route as AuthenticatedAppSettingsRetentionRouteImport } from './routes/_authenticated/app/settings.retention'
import { Route as AuthenticatedAppSettingsOnCallRouteImport } from './routes/_authenticated/app/settings.on-call'
import { Route as AuthenticatedAppSettingsNotificationsRouteImport } from './routes/_authenticated/app/settings.notifications'
import { Route as AuthenticatedAppSettingsIncidentsRouteImport } from './routes/_authenticated/app/settings.incidents'
import { Route as AuthenticatedAppSettingsDataOwnershipRouteImport } from './routes/_authenticated/app/settings.data-ownership'
import { Route as AuthenticatedAppSettingsComplianceRouteImport } from './routes/_authenticated/app/settings.compliance'
import { Route as AuthenticatedAppSettingsAuditLogRouteImport } from './routes/_authenticated/app/settings.audit-log'
import { Route as AuthenticatedAppSettingsApiKeysRouteImport } from './routes/_authenticated/app/settings.api-keys'
import { Route as AuthenticatedAppPackBulkRouteImport } from './routes/_authenticated/app/pack/bulk'
import { Route as AuthenticatedAppPackBatchRouteImport } from './routes/_authenticated/app/pack/batch'
import { Route as AuthenticatedAppPackOrderIdRouteImport } from './routes/_authenticated/app/pack/$orderId'
import { Route as AuthenticatedAppBillingRulesRouteImport } from './routes/_authenticated/app/billing.rules'
import { Route as AuthenticatedAppBillingProfitabilityRouteImport } from './routes/_authenticated/app/billing.profitability'
import { Route as AuthenticatedAppBillingAnomaliesRouteImport } from './routes/_authenticated/app/billing.anomalies'
import { Route as AuthenticatedAppWarehouseMapIndexRouteImport } from './routes/_authenticated/app/warehouse-map.index'
import { Route as AuthenticatedAppWarehouseMapSlottingRouteImport } from './routes/_authenticated/app/warehouse-map.slotting'
import { Route as AuthenticatedAppWarehouseMapMovementRouteImport } from './routes/_authenticated/app/warehouse-map.movement'
import { Route as AuthenticatedAppWarehouseMapLocationsRouteImport } from './routes/_authenticated/app/warehouse-map.locations'
import { Route as AuthenticatedAppWarehouseMapHeatmapRouteImport } from './routes/_authenticated/app/warehouse-map.heatmap'
import { Route as AuthenticatedAppTransfersIndexRouteImport } from './routes/_authenticated/app/transfers.index'
import { Route as AuthenticatedAppTransfersIdRouteImport } from './routes/_authenticated/app/transfers.$id'
import { Route as AuthenticatedAppSlottingIndexRouteImport } from './routes/_authenticated/app/slotting.index'
import { Route as AuthenticatedAppSlottingHeatmapRouteImport } from './routes/_authenticated/app/slotting.heatmap'
import { Route as AuthenticatedAppSlottingAbcRouteImport } from './routes/_authenticated/app/slotting.abc'
import { Route as AuthenticatedAppShipmentsIndexRouteImport } from './routes/_authenticated/app/shipments.index'
import { Route as AuthenticatedAppShipmentsShipmentIdRouteImport } from './routes/_authenticated/app/shipments.$shipmentId'
import { Route as AuthenticatedAppRfIndexRouteImport } from './routes/_authenticated/app/rf.index'
import { Route as AuthenticatedAppRfTransfersRouteImport } from './routes/_authenticated/app/rf.transfers'
import { Route as AuthenticatedAppRfReturnsRouteImport } from './routes/_authenticated/app/rf.returns'
import { Route as AuthenticatedAppRfReplenishmentRouteImport } from './routes/_authenticated/app/rf.replenishment'
import { Route as AuthenticatedAppRfReceivingRouteImport } from './routes/_authenticated/app/rf.receiving'
import { Route as AuthenticatedAppRfPutawayRouteImport } from './routes/_authenticated/app/rf.putaway'
import { Route as AuthenticatedAppRfPickRouteImport } from './routes/_authenticated/app/rf.pick'
import { Route as AuthenticatedAppRfCycleCountRouteImport } from './routes/_authenticated/app/rf.cycle-count'
import { Route as AuthenticatedAppReportsIndexRouteImport } from './routes/_authenticated/app/reports.index'
import { Route as AuthenticatedAppReportsWarehouseRouteImport } from './routes/_authenticated/app/reports.warehouse'
import { Route as AuthenticatedAppReportsShippingRouteImport } from './routes/_authenticated/app/reports.shipping'
import { Route as AuthenticatedAppReportsReceivingRouteImport } from './routes/_authenticated/app/reports.receiving'
import { Route as AuthenticatedAppReportsInventoryRouteImport } from './routes/_authenticated/app/reports.inventory'
import { Route as AuthenticatedAppReportsBuilderRouteImport } from './routes/_authenticated/app/reports.builder'
import { Route as AuthenticatedAppReportsBillingRouteImport } from './routes/_authenticated/app/reports.billing'
import { Route as AuthenticatedAppReceivingIndexRouteImport } from './routes/_authenticated/app/receiving/index'
import { Route as AuthenticatedAppReceivingScorecardRouteImport } from './routes/_authenticated/app/receiving/scorecard'
import { Route as AuthenticatedAppReceivingAsnIdRouteImport } from './routes/_authenticated/app/receiving/$asnId'
import { Route as AuthenticatedAppPoliciesIndexRouteImport } from './routes/_authenticated/app/policies.index'
import { Route as AuthenticatedAppPoliciesPrototypeRouteImport } from './routes/_authenticated/app/policies.prototype'
import { Route as AuthenticatedAppPoliciesLibraryRouteImport } from './routes/_authenticated/app/policies.library'
import { Route as AuthenticatedAppPoliciesPolicyIdRouteImport } from './routes/_authenticated/app/policies.$policyId'
import { Route as AuthenticatedAppPlaybookIndexRouteImport } from './routes/_authenticated/app/playbook.index'
import { Route as AuthenticatedAppPlaybookSearchRouteImport } from './routes/_authenticated/app/playbook.search'
import { Route as AuthenticatedAppPlaybookSplatRouteImport } from './routes/_authenticated/app/playbook.$'
import { Route as AuthenticatedAppPickIndexRouteImport } from './routes/_authenticated/app/pick/index'
import { Route as AuthenticatedAppPickWavesRouteImport } from './routes/_authenticated/app/pick/waves'
import { Route as AuthenticatedAppOrdersIndexRouteImport } from './routes/_authenticated/app/orders/index'
import { Route as AuthenticatedAppOrdersNewRouteImport } from './routes/_authenticated/app/orders/new'
import { Route as AuthenticatedAppOrdersOrderIdRouteImport } from './routes/_authenticated/app/orders/$orderId'
import { Route as AuthenticatedAppOperationsIndexRouteImport } from './routes/_authenticated/app/operations.index'
import { Route as AuthenticatedAppOperationsDeskRouteImport } from './routes/_authenticated/app/operations.desk'
import { Route as AuthenticatedAppOperationsActiveWorkRouteImport } from './routes/_authenticated/app/operations.active-work'
import { Route as AuthenticatedAppLaborIndexRouteImport } from './routes/_authenticated/app/labor.index'
import { Route as AuthenticatedAppLaborRatesRouteImport } from './routes/_authenticated/app/labor.rates'
import { Route as AuthenticatedAppLaborIncentivesRouteImport } from './routes/_authenticated/app/labor.incentives'
import { Route as AuthenticatedAppLaborForecastRouteImport } from './routes/_authenticated/app/labor.forecast'
import { Route as AuthenticatedAppInventoryStrandedRouteImport } from './routes/_authenticated/app/inventory/stranded'
import { Route as AuthenticatedAppInventoryStateRouteImport } from './routes/_authenticated/app/inventory/state'
import { Route as AuthenticatedAppInventorySkusRouteImport } from './routes/_authenticated/app/inventory/skus'
import { Route as AuthenticatedAppInventorySerialsRouteImport } from './routes/_authenticated/app/inventory/serials'
import { Route as AuthenticatedAppInventoryOnHandRouteImport } from './routes/_authenticated/app/inventory/on-hand'
import { Route as AuthenticatedAppInventoryMovementsRouteImport } from './routes/_authenticated/app/inventory/movements'
import { Route as AuthenticatedAppInventoryLowStockRouteImport } from './routes/_authenticated/app/inventory/low-stock'
import { Route as AuthenticatedAppInventoryLotsRouteImport } from './routes/_authenticated/app/inventory/lots'
import { Route as AuthenticatedAppInventoryLocationsRouteImport } from './routes/_authenticated/app/inventory/locations'
import { Route as AuthenticatedAppInventoryKitsRouteImport } from './routes/_authenticated/app/inventory/kits'
import { Route as AuthenticatedAppInventoryHoldsRouteImport } from './routes/_authenticated/app/inventory/holds'
import { Route as AuthenticatedAppInventoryExpiringRouteImport } from './routes/_authenticated/app/inventory/expiring'
import { Route as AuthenticatedAppInventoryBundlesRouteImport } from './routes/_authenticated/app/inventory/bundles'
import { Route as AuthenticatedAppImplementationIndexRouteImport } from './routes/_authenticated/app/implementation.index'
import { Route as AuthenticatedAppImplementationWorkspaceRouteImport } from './routes/_authenticated/app/implementation.workspace'
import { Route as AuthenticatedAppImplementationLaunchKitPreviewRouteImport } from './routes/_authenticated/app/implementation.launch-kit-preview'
import { Route as AuthenticatedAppForecastingIndexRouteImport } from './routes/_authenticated/app/forecasting.index'
import { Route as AuthenticatedAppForecastingSuggestionsRouteImport } from './routes/_authenticated/app/forecasting.suggestions'
import { Route as AuthenticatedAppForecastingPoliciesRouteImport } from './routes/_authenticated/app/forecasting.policies'
import { Route as AuthenticatedAppForecastingAlertsRouteImport } from './routes/_authenticated/app/forecasting.alerts'
import { Route as AuthenticatedAppCycleCountsIndexRouteImport } from './routes/_authenticated/app/cycle-counts.index'
import { Route as AuthenticatedAppCycleCountsIdRouteImport } from './routes/_authenticated/app/cycle-counts.$id'
import { Route as AuthenticatedAppComplianceIndexRouteImport } from './routes/_authenticated/app/compliance.index'
import { Route as AuthenticatedAppComplianceTraceRouteImport } from './routes/_authenticated/app/compliance.trace'
import { Route as AuthenticatedAppComplianceRecallsRouteImport } from './routes/_authenticated/app/compliance.recalls'
import { Route as AuthenticatedAppAdminWorkflowsRouteImport } from './routes/_authenticated/app/admin/workflows'
import { Route as AuthenticatedAppAdminWebhooksRouteImport } from './routes/_authenticated/app/admin/webhooks'
import { Route as AuthenticatedAppAdminWavePoliciesRouteImport } from './routes/_authenticated/app/admin/wave-policies'
import { Route as AuthenticatedAppAdminUsersRouteImport } from './routes/_authenticated/app/admin/users'
import { Route as AuthenticatedAppAdminTraceabilityRouteImport } from './routes/_authenticated/app/admin/traceability'
import { Route as AuthenticatedAppAdminTenantsRouteImport } from './routes/_authenticated/app/admin/tenants'
import { Route as AuthenticatedAppAdminTemplatesRouteImport } from './routes/_authenticated/app/admin/templates'
import { Route as AuthenticatedAppAdminStatusRouteImport } from './routes/_authenticated/app/admin/status'
import { Route as AuthenticatedAppAdminSlottingRouteImport } from './routes/_authenticated/app/admin/slotting'
import { Route as AuthenticatedAppAdminSlackRouteImport } from './routes/_authenticated/app/admin/slack'
import { Route as AuthenticatedAppAdminShippingPoliciesRouteImport } from './routes/_authenticated/app/admin/shipping-policies'
import { Route as AuthenticatedAppAdminRulesRouteImport } from './routes/_authenticated/app/admin/rules'
import { Route as AuthenticatedAppAdminRoutingRouteImport } from './routes/_authenticated/app/admin/routing'
import { Route as AuthenticatedAppAdminReturnsConfigRouteImport } from './routes/_authenticated/app/admin/returns-config'
import { Route as AuthenticatedAppAdminReplenishmentRouteImport } from './routes/_authenticated/app/admin/replenishment'
import { Route as AuthenticatedAppAdminReconciliationRouteImport } from './routes/_authenticated/app/admin/reconciliation'
import { Route as AuthenticatedAppAdminReceivingPoliciesRouteImport } from './routes/_authenticated/app/admin/receiving-policies'
import { Route as AuthenticatedAppAdminPutawayRouteImport } from './routes/_authenticated/app/admin/putaway'
import { Route as AuthenticatedAppAdminPrintQueueRouteImport } from './routes/_authenticated/app/admin/print-queue'
import { Route as AuthenticatedAppAdminPortalReportsRouteImport } from './routes/_authenticated/app/admin/portal-reports'
import { Route as AuthenticatedAppAdminPolicyParityRouteImport } from './routes/_authenticated/app/admin/policy-parity'
import { Route as AuthenticatedAppAdminOperationalSignalsRouteImport } from './routes/_authenticated/app/admin/operational-signals'
import { Route as AuthenticatedAppAdminOncallRouteImport } from './routes/_authenticated/app/admin/oncall'
import { Route as AuthenticatedAppAdminOnboardingRouteImport } from './routes/_authenticated/app/admin/onboarding'
import { Route as AuthenticatedAppAdminObservabilityRouteImport } from './routes/_authenticated/app/admin/observability'
import { Route as AuthenticatedAppAdminNotificationsRouteImport } from './routes/_authenticated/app/admin/notifications'
import { Route as AuthenticatedAppAdminManifestsRouteImport } from './routes/_authenticated/app/admin/manifests'
import { Route as AuthenticatedAppAdminJobsRouteImport } from './routes/_authenticated/app/admin/jobs'
import { Route as AuthenticatedAppAdminInventoryPlanningPoliciesRouteImport } from './routes/_authenticated/app/admin/inventory-planning-policies'
import { Route as AuthenticatedAppAdminInventoryAdjustmentsRouteImport } from './routes/_authenticated/app/admin/inventory-adjustments'
import { Route as AuthenticatedAppAdminHoldRulesRouteImport } from './routes/_authenticated/app/admin/hold-rules'
import { Route as AuthenticatedAppAdminHoldCreationRouteImport } from './routes/_authenticated/app/admin/hold-creation'
import { Route as AuthenticatedAppAdminHardwareRouteImport } from './routes/_authenticated/app/admin/hardware'
import { Route as AuthenticatedAppAdminGoogleRouteImport } from './routes/_authenticated/app/admin/google'
import { Route as AuthenticatedAppAdminFulfillmentRouteImport } from './routes/_authenticated/app/admin/fulfillment'
import { Route as AuthenticatedAppAdminFreightRouteImport } from './routes/_authenticated/app/admin/freight'
import { Route as AuthenticatedAppAdminFacilitiesRouteImport } from './routes/_authenticated/app/admin/facilities'
import { Route as AuthenticatedAppAdminExchangeRunsRouteImport } from './routes/_authenticated/app/admin/exchange-runs'
import { Route as AuthenticatedAppAdminEnterpriseRouteImport } from './routes/_authenticated/app/admin/enterprise'
import { Route as AuthenticatedAppAdminEdiRouteImport } from './routes/_authenticated/app/admin/edi'
import { Route as AuthenticatedAppAdminDevicesRouteImport } from './routes/_authenticated/app/admin/devices'
import { Route as AuthenticatedAppAdminDeliveryCommitmentPoliciesRouteImport } from './routes/_authenticated/app/admin/delivery-commitment-policies'
import { Route as AuthenticatedAppAdminCycleCountSchedulesRouteImport } from './routes/_authenticated/app/admin/cycle-count-schedules'
import { Route as AuthenticatedAppAdminCustomerFacilitiesRouteImport } from './routes/_authenticated/app/admin/customer-facilities'
import { Route as AuthenticatedAppAdminCustomFieldsRouteImport } from './routes/_authenticated/app/admin/custom-fields'
import { Route as AuthenticatedAppAdminCostToServeRouteImport } from './routes/_authenticated/app/admin/cost-to-serve'
import { Route as AuthenticatedAppAdminConsumablesRouteImport } from './routes/_authenticated/app/admin/consumables'
import { Route as AuthenticatedAppAdminComplianceRouteImport } from './routes/_authenticated/app/admin/compliance'
import { Route as AuthenticatedAppAdminCarriersRouteImport } from './routes/_authenticated/app/admin/carriers'
import { Route as AuthenticatedAppAdminBlueprintsRouteImport } from './routes/_authenticated/app/admin/blueprints'
import { Route as AuthenticatedAppAdminBillingPlatformRouteImport } from './routes/_authenticated/app/admin/billing-platform'
import { Route as AuthenticatedAppAdminBillingRouteImport } from './routes/_authenticated/app/admin/billing'
import { Route as AuthenticatedAppAdminAuditRouteImport } from './routes/_authenticated/app/admin/audit'
import { Route as AuthenticatedAppAdminApiKeysRouteImport } from './routes/_authenticated/app/admin/api-keys'
import { Route as AuthenticatedAppAdminAlertsRouteImport } from './routes/_authenticated/app/admin/alerts'
import { Route as AuthenticatedAppManifestsManifestIdPrintRouteImport } from './routes/_authenticated/app/manifests.$manifestId.print'
import { Route as AuthenticatedAppBillingCustomersCustomerIdRouteImport } from './routes/_authenticated/app/billing.customers.$customerId'
import { Route as AuthenticatedAppBillingInvoiceIdPrintRouteImport } from './routes/_authenticated/app/billing.$invoiceId.print'
import { Route as AuthenticatedAppPackOrderIdPackingSlipRouteImport } from './routes/_authenticated/app/pack/$orderId.packing-slip'
import { Route as AuthenticatedAppShipmentsShipmentIdIndexRouteImport } from './routes/_authenticated/app/shipments.$shipmentId.index'
import { Route as AuthenticatedAppShipmentsShipmentIdPalletLabelsRouteImport } from './routes/_authenticated/app/shipments.$shipmentId.pallet-labels'
import { Route as AuthenticatedAppShipmentsShipmentIdBolRouteImport } from './routes/_authenticated/app/shipments.$shipmentId.bol'
import { Route as AuthenticatedAppRfReturnsRmaIdRouteImport } from './routes/_authenticated/app/rf.returns.$rmaId'
import { Route as AuthenticatedAppRfReceivingAsnIdRouteImport } from './routes/_authenticated/app/rf.receiving.$asnId'
import { Route as AuthenticatedAppRfCycleCountIdRouteImport } from './routes/_authenticated/app/rf.cycle-count.$id'
import { Route as AuthenticatedAppPickSessionSessionIdRouteImport } from './routes/_authenticated/app/pick/session.$sessionId'
import { Route as AuthenticatedAppPickWavesIndexRouteImport } from './routes/_authenticated/app/pick/waves.index'
import { Route as AuthenticatedAppPickWavesWaveIdRouteImport } from './routes/_authenticated/app/pick/waves.$waveId'
import { Route as AuthenticatedAppOrdersOrderIdPackingSlipRouteImport } from './routes/_authenticated/app/orders/$orderId.packing-slip'
import { Route as AuthenticatedAppInventoryLocationsLocationIdRouteImport } from './routes/_authenticated/app/inventory/locations.$locationId'
import { Route as AuthenticatedAppInventoryKitsIndexRouteImport } from './routes/_authenticated/app/inventory/kits.index'
import { Route as AuthenticatedAppInventoryKitsWorkOrderIdRouteImport } from './routes/_authenticated/app/inventory/kits.$workOrderId'
import { Route as AuthenticatedAppImplementationWorkspaceIndexRouteImport } from './routes/_authenticated/app/implementation.workspace.index'
import { Route as AuthenticatedAppImplementationWorkspaceValidationRouteImport } from './routes/_authenticated/app/implementation.workspace.validation'
import { Route as AuthenticatedAppImplementationWorkspaceOperationsRouteImport } from './routes/_authenticated/app/implementation.workspace.operations'
import { Route as AuthenticatedAppImplementationWorkspaceFoundationRouteImport } from './routes/_authenticated/app/implementation.workspace.foundation'
import { Route as AuthenticatedAppImplementationWorkspaceDataRouteImport } from './routes/_authenticated/app/implementation.workspace.data'
import { Route as AuthenticatedAppForecastingSkuSkuIdRouteImport } from './routes/_authenticated/app/forecasting.sku.$skuId'
import { Route as AuthenticatedAppComplianceRecallsIndexRouteImport } from './routes/_authenticated/app/compliance.recalls.index'
import { Route as AuthenticatedAppComplianceRecallsIdRouteImport } from './routes/_authenticated/app/compliance.recalls.$id'
import { Route as AuthenticatedAppAdminIntegrationsIndexRouteImport } from './routes/_authenticated/app/admin/integrations.index'
import { Route as AuthenticatedAppAdminCustomersIndexRouteImport } from './routes/_authenticated/app/admin/customers.index'
import { Route as AuthenticatedAppAdminConnectionsIndexRouteImport } from './routes/_authenticated/app/admin/connections.index'
import { Route as AuthenticatedAppAdminIntegrationsConnectionIdRouteImport } from './routes/_authenticated/app/admin/integrations.$connectionId'
import { Route as AuthenticatedAppAdminConnectionsConnectionIdRouteImport } from './routes/_authenticated/app/admin/connections.$connectionId'
import { Route as AuthenticatedAppAdminPortalReportsIndexRouteImport } from './routes/_authenticated/app/admin/portal-reports.index'
import { Route as AuthenticatedAppAdminPortalReportsAccessRouteImport } from './routes/_authenticated/app/admin/portal-reports.access'
import { Route as AuthenticatedAppAdminHoldRulesAdvancedRouteImport } from './routes/_authenticated/app/admin/hold-rules.advanced'
import { Route as AuthenticatedAppAdminHoldCreationAdvancedRouteImport } from './routes/_authenticated/app/admin/hold-creation.advanced'
import { Route as AuthenticatedAppAdminExchangeRunsRunIdRouteImport } from './routes/_authenticated/app/admin/exchange-runs.$runId'
import { Route as AuthenticatedAppShipmentsShipmentIdBolPrintRouteImport } from './routes/_authenticated/app/shipments.$shipmentId.bol.print'
import { Route as AuthenticatedAppAdminIntegrationsCartroverConnectionIdRouteImport } from './routes/_authenticated/app/admin/integrations.cartrover.$connectionId'
import { Route as AuthenticatedAppAdminCustomersCustomerIdIntegrationsRouteImport } from './routes/_authenticated/app/admin/customers.$customerId.integrations'
import { Route as AuthenticatedAppAdminCustomersCustomerIdCarriersRouteImport } from './routes/_authenticated/app/admin/customers.$customerId.carriers'
import { Route as AuthenticatedAppAdminBillingPlatformContractsCustomerIdRouteImport } from './routes/_authenticated/app/admin/billing-platform.contracts.$customerId'

const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const NoAccessRoute = NoAccessRouteImport.update({
            id: '/no-access',path: '/no-access',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedSetupRoute = AuthenticatedSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedScoreboardRoute = AuthenticatedScoreboardRouteImport.update({
            id: '/scoreboard',path: '/scoreboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppRoute = AuthenticatedAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPortalWorkspaceRoute = AuthenticatedPortalWorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalSlaRoute = AuthenticatedPortalSlaRouteImport.update({
            id: '/sla',path: '/sla',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalSettingsRoute = AuthenticatedPortalSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalRmasRoute = AuthenticatedPortalRmasRouteImport.update({
            id: '/rmas',path: '/rmas',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalReportsRoute = AuthenticatedPortalReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalProfitabilityRoute = AuthenticatedPortalProfitabilityRouteImport.update({
            id: '/profitability',path: '/profitability',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalOrdersRoute = AuthenticatedPortalOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInvoicesRoute = AuthenticatedPortalInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInventoryRoute = AuthenticatedPortalInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInboundRoute = AuthenticatedPortalInboundRouteImport.update({
            id: '/inbound',path: '/inbound',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalDashboardRoute = AuthenticatedPortalDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalCreditsRoute = AuthenticatedPortalCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalChatRoute = AuthenticatedPortalChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedAppYardRoute = AuthenticatedAppYardRouteImport.update({
            id: '/yard',path: '/yard',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppWarehouseMapRoute = AuthenticatedAppWarehouseMapRouteImport.update({
            id: '/warehouse-map',path: '/warehouse-map',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppTransfersRoute = AuthenticatedAppTransfersRouteImport.update({
            id: '/transfers',path: '/transfers',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppTasksRoute = AuthenticatedAppTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSuppliersRoute = AuthenticatedAppSuppliersRouteImport.update({
            id: '/suppliers',path: '/suppliers',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSlottingRoute = AuthenticatedAppSlottingRouteImport.update({
            id: '/slotting',path: '/slotting',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppShipmentsRoute = AuthenticatedAppShipmentsRouteImport.update({
            id: '/shipments',path: '/shipments',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppScanRoute = AuthenticatedAppScanRouteImport.update({
            id: '/scan',path: '/scan',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppRfRoute = AuthenticatedAppRfRouteImport.update({
            id: '/rf',path: '/rf',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReturnsRulesRoute = AuthenticatedAppReturnsRulesRouteImport.update({
            id: '/returns-rules',path: '/returns-rules',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReturnsRefurbRoute = AuthenticatedAppReturnsRefurbRouteImport.update({
            id: '/returns-refurb',path: '/returns-refurb',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReturnsReceivingRoute = AuthenticatedAppReturnsReceivingRouteImport.update({
            id: '/returns-receiving',path: '/returns-receiving',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReturnsDispositionRoute = AuthenticatedAppReturnsDispositionRouteImport.update({
            id: '/returns-disposition',path: '/returns-disposition',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReturnsCreditsRoute = AuthenticatedAppReturnsCreditsRouteImport.update({
            id: '/returns-credits',path: '/returns-credits',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReturnsRoute = AuthenticatedAppReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReportsRoute = AuthenticatedAppReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppReceivingRoute = AuthenticatedAppReceivingRouteImport.update({
            id: '/receiving',path: '/receiving',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppQualityIntelligenceRoute = AuthenticatedAppQualityIntelligenceRouteImport.update({
            id: '/quality-intelligence',path: '/quality-intelligence',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPutawayRoute = AuthenticatedAppPutawayRouteImport.update({
            id: '/putaway',path: '/putaway',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPoliciesRoute = AuthenticatedAppPoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPlaybookRoute = AuthenticatedAppPlaybookRouteImport.update({
            id: '/playbook',path: '/playbook',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPickRoute = AuthenticatedAppPickRouteImport.update({
            id: '/pick',path: '/pick',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppOrdersRoute = AuthenticatedAppOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppOperationsRoute = AuthenticatedAppOperationsRouteImport.update({
            id: '/operations',path: '/operations',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppOnboardingRoute = AuthenticatedAppOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppLaborRoute = AuthenticatedAppLaborRouteImport.update({
            id: '/labor',path: '/labor',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppLabelsRoute = AuthenticatedAppLabelsRouteImport.update({
            id: '/labels',path: '/labels',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppInventoryRoute = AuthenticatedAppInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppImportsRoute = AuthenticatedAppImportsRouteImport.update({
            id: '/imports',path: '/imports',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppImplementationRoute = AuthenticatedAppImplementationRouteImport.update({
            id: '/implementation',path: '/implementation',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppForecastingRoute = AuthenticatedAppForecastingRouteImport.update({
            id: '/forecasting',path: '/forecasting',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppExceptionsRoute = AuthenticatedAppExceptionsRouteImport.update({
            id: '/exceptions',path: '/exceptions',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppDockRoute = AuthenticatedAppDockRouteImport.update({
            id: '/dock',path: '/dock',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppDashboardRoute = AuthenticatedAppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppCycleCountsRoute = AuthenticatedAppCycleCountsRouteImport.update({
            id: '/cycle-counts',path: '/cycle-counts',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppComplianceRoute = AuthenticatedAppComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppChatRoute = AuthenticatedAppChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminRoute = AuthenticatedAppAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedPortalRmasRmaIdRoute = AuthenticatedPortalRmasRmaIdRouteImport.update({
            id: '/$rmaId',path: '/$rmaId',getParentRoute: () => AuthenticatedPortalRmasRoute
          })
const AuthenticatedPortalReportsIndexRoute = AuthenticatedPortalReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPortalReportsRoute
          })
const AuthenticatedPortalReportsSubscriptionsRoute = AuthenticatedPortalReportsSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthenticatedPortalReportsRoute
          })
const AuthenticatedPortalReportsHistoryRoute = AuthenticatedPortalReportsHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedPortalReportsRoute
          })
const AuthenticatedPortalReportsReportKeyRoute = AuthenticatedPortalReportsReportKeyRouteImport.update({
            id: '/$reportKey',path: '/$reportKey',getParentRoute: () => AuthenticatedPortalReportsRoute
          })
const AuthenticatedPortalOrdersNewRoute = AuthenticatedPortalOrdersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedPortalOrdersRoute
          })
const AuthenticatedPortalOrdersOrderIdRoute = AuthenticatedPortalOrdersOrderIdRouteImport.update({
            id: '/$orderId',path: '/$orderId',getParentRoute: () => AuthenticatedPortalOrdersRoute
          })
const AuthenticatedPortalInboundAsnIdRoute = AuthenticatedPortalInboundAsnIdRouteImport.update({
            id: '/$asnId',path: '/$asnId',getParentRoute: () => AuthenticatedPortalInboundRoute
          })
const AuthenticatedAppPackIndexRoute = AuthenticatedAppPackIndexRouteImport.update({
            id: '/pack/',path: '/pack/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppManifestsIndexRoute = AuthenticatedAppManifestsIndexRouteImport.update({
            id: '/manifests/',path: '/manifests/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBolsIndexRoute = AuthenticatedAppBolsIndexRouteImport.update({
            id: '/bols/',path: '/bols/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingIndexRoute = AuthenticatedAppBillingIndexRouteImport.update({
            id: '/billing/',path: '/billing/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppTraceabilityRefRoute = AuthenticatedAppTraceabilityRefRouteImport.update({
            id: '/traceability/$ref',path: '/traceability/$ref',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppTraceCaptureRoute = AuthenticatedAppTraceCaptureRouteImport.update({
            id: '/trace/capture',path: '/trace/capture',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsWebhooksRoute = AuthenticatedAppSettingsWebhooksRouteImport.update({
            id: '/settings/webhooks',path: '/settings/webhooks',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsStatusSubscribersRoute = AuthenticatedAppSettingsStatusSubscribersRouteImport.update({
            id: '/settings/status-subscribers',path: '/settings/status-subscribers',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsStatusRoute = AuthenticatedAppSettingsStatusRouteImport.update({
            id: '/settings/status',path: '/settings/status',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsSsoRoute = AuthenticatedAppSettingsSsoRouteImport.update({
            id: '/settings/sso',path: '/settings/sso',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsShipmentIssuesRoute = AuthenticatedAppSettingsShipmentIssuesRouteImport.update({
            id: '/settings/shipment-issues',path: '/settings/shipment-issues',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsScimRoute = AuthenticatedAppSettingsScimRouteImport.update({
            id: '/settings/scim',path: '/settings/scim',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsRetentionRoute = AuthenticatedAppSettingsRetentionRouteImport.update({
            id: '/settings/retention',path: '/settings/retention',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsOnCallRoute = AuthenticatedAppSettingsOnCallRouteImport.update({
            id: '/settings/on-call',path: '/settings/on-call',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsNotificationsRoute = AuthenticatedAppSettingsNotificationsRouteImport.update({
            id: '/settings/notifications',path: '/settings/notifications',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsIncidentsRoute = AuthenticatedAppSettingsIncidentsRouteImport.update({
            id: '/settings/incidents',path: '/settings/incidents',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsDataOwnershipRoute = AuthenticatedAppSettingsDataOwnershipRouteImport.update({
            id: '/settings/data-ownership',path: '/settings/data-ownership',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsComplianceRoute = AuthenticatedAppSettingsComplianceRouteImport.update({
            id: '/settings/compliance',path: '/settings/compliance',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsAuditLogRoute = AuthenticatedAppSettingsAuditLogRouteImport.update({
            id: '/settings/audit-log',path: '/settings/audit-log',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsApiKeysRoute = AuthenticatedAppSettingsApiKeysRouteImport.update({
            id: '/settings/api-keys',path: '/settings/api-keys',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPackBulkRoute = AuthenticatedAppPackBulkRouteImport.update({
            id: '/pack/bulk',path: '/pack/bulk',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPackBatchRoute = AuthenticatedAppPackBatchRouteImport.update({
            id: '/pack/batch',path: '/pack/batch',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPackOrderIdRoute = AuthenticatedAppPackOrderIdRouteImport.update({
            id: '/pack/$orderId',path: '/pack/$orderId',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingRulesRoute = AuthenticatedAppBillingRulesRouteImport.update({
            id: '/billing/rules',path: '/billing/rules',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingProfitabilityRoute = AuthenticatedAppBillingProfitabilityRouteImport.update({
            id: '/billing/profitability',path: '/billing/profitability',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingAnomaliesRoute = AuthenticatedAppBillingAnomaliesRouteImport.update({
            id: '/billing/anomalies',path: '/billing/anomalies',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppWarehouseMapIndexRoute = AuthenticatedAppWarehouseMapIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppWarehouseMapRoute
          })
const AuthenticatedAppWarehouseMapSlottingRoute = AuthenticatedAppWarehouseMapSlottingRouteImport.update({
            id: '/slotting',path: '/slotting',getParentRoute: () => AuthenticatedAppWarehouseMapRoute
          })
const AuthenticatedAppWarehouseMapMovementRoute = AuthenticatedAppWarehouseMapMovementRouteImport.update({
            id: '/movement',path: '/movement',getParentRoute: () => AuthenticatedAppWarehouseMapRoute
          })
const AuthenticatedAppWarehouseMapLocationsRoute = AuthenticatedAppWarehouseMapLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => AuthenticatedAppWarehouseMapRoute
          })
const AuthenticatedAppWarehouseMapHeatmapRoute = AuthenticatedAppWarehouseMapHeatmapRouteImport.update({
            id: '/heatmap',path: '/heatmap',getParentRoute: () => AuthenticatedAppWarehouseMapRoute
          })
const AuthenticatedAppTransfersIndexRoute = AuthenticatedAppTransfersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppTransfersRoute
          })
const AuthenticatedAppTransfersIdRoute = AuthenticatedAppTransfersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppTransfersRoute
          })
const AuthenticatedAppSlottingIndexRoute = AuthenticatedAppSlottingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppSlottingRoute
          })
const AuthenticatedAppSlottingHeatmapRoute = AuthenticatedAppSlottingHeatmapRouteImport.update({
            id: '/heatmap',path: '/heatmap',getParentRoute: () => AuthenticatedAppSlottingRoute
          })
const AuthenticatedAppSlottingAbcRoute = AuthenticatedAppSlottingAbcRouteImport.update({
            id: '/abc',path: '/abc',getParentRoute: () => AuthenticatedAppSlottingRoute
          })
const AuthenticatedAppShipmentsIndexRoute = AuthenticatedAppShipmentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppShipmentsRoute
          })
const AuthenticatedAppShipmentsShipmentIdRoute = AuthenticatedAppShipmentsShipmentIdRouteImport.update({
            id: '/$shipmentId',path: '/$shipmentId',getParentRoute: () => AuthenticatedAppShipmentsRoute
          })
const AuthenticatedAppRfIndexRoute = AuthenticatedAppRfIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfTransfersRoute = AuthenticatedAppRfTransfersRouteImport.update({
            id: '/transfers',path: '/transfers',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfReturnsRoute = AuthenticatedAppRfReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfReplenishmentRoute = AuthenticatedAppRfReplenishmentRouteImport.update({
            id: '/replenishment',path: '/replenishment',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfReceivingRoute = AuthenticatedAppRfReceivingRouteImport.update({
            id: '/receiving',path: '/receiving',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfPutawayRoute = AuthenticatedAppRfPutawayRouteImport.update({
            id: '/putaway',path: '/putaway',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfPickRoute = AuthenticatedAppRfPickRouteImport.update({
            id: '/pick',path: '/pick',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppRfCycleCountRoute = AuthenticatedAppRfCycleCountRouteImport.update({
            id: '/cycle-count',path: '/cycle-count',getParentRoute: () => AuthenticatedAppRfRoute
          })
const AuthenticatedAppReportsIndexRoute = AuthenticatedAppReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReportsWarehouseRoute = AuthenticatedAppReportsWarehouseRouteImport.update({
            id: '/warehouse',path: '/warehouse',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReportsShippingRoute = AuthenticatedAppReportsShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReportsReceivingRoute = AuthenticatedAppReportsReceivingRouteImport.update({
            id: '/receiving',path: '/receiving',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReportsInventoryRoute = AuthenticatedAppReportsInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReportsBuilderRoute = AuthenticatedAppReportsBuilderRouteImport.update({
            id: '/builder',path: '/builder',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReportsBillingRoute = AuthenticatedAppReportsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedAppReportsRoute
          })
const AuthenticatedAppReceivingIndexRoute = AuthenticatedAppReceivingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppReceivingRoute
          })
const AuthenticatedAppReceivingScorecardRoute = AuthenticatedAppReceivingScorecardRouteImport.update({
            id: '/scorecard',path: '/scorecard',getParentRoute: () => AuthenticatedAppReceivingRoute
          })
const AuthenticatedAppReceivingAsnIdRoute = AuthenticatedAppReceivingAsnIdRouteImport.update({
            id: '/$asnId',path: '/$asnId',getParentRoute: () => AuthenticatedAppReceivingRoute
          })
const AuthenticatedAppPoliciesIndexRoute = AuthenticatedAppPoliciesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppPoliciesRoute
          })
const AuthenticatedAppPoliciesPrototypeRoute = AuthenticatedAppPoliciesPrototypeRouteImport.update({
            id: '/prototype',path: '/prototype',getParentRoute: () => AuthenticatedAppPoliciesRoute
          })
const AuthenticatedAppPoliciesLibraryRoute = AuthenticatedAppPoliciesLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => AuthenticatedAppPoliciesRoute
          })
const AuthenticatedAppPoliciesPolicyIdRoute = AuthenticatedAppPoliciesPolicyIdRouteImport.update({
            id: '/$policyId',path: '/$policyId',getParentRoute: () => AuthenticatedAppPoliciesRoute
          })
const AuthenticatedAppPlaybookIndexRoute = AuthenticatedAppPlaybookIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppPlaybookRoute
          })
const AuthenticatedAppPlaybookSearchRoute = AuthenticatedAppPlaybookSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => AuthenticatedAppPlaybookRoute
          })
const AuthenticatedAppPlaybookSplatRoute = AuthenticatedAppPlaybookSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AuthenticatedAppPlaybookRoute
          })
const AuthenticatedAppPickIndexRoute = AuthenticatedAppPickIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppPickRoute
          })
const AuthenticatedAppPickWavesRoute = AuthenticatedAppPickWavesRouteImport.update({
            id: '/waves',path: '/waves',getParentRoute: () => AuthenticatedAppPickRoute
          })
const AuthenticatedAppOrdersIndexRoute = AuthenticatedAppOrdersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppOrdersRoute
          })
const AuthenticatedAppOrdersNewRoute = AuthenticatedAppOrdersNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedAppOrdersRoute
          })
const AuthenticatedAppOrdersOrderIdRoute = AuthenticatedAppOrdersOrderIdRouteImport.update({
            id: '/$orderId',path: '/$orderId',getParentRoute: () => AuthenticatedAppOrdersRoute
          })
const AuthenticatedAppOperationsIndexRoute = AuthenticatedAppOperationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppOperationsRoute
          })
const AuthenticatedAppOperationsDeskRoute = AuthenticatedAppOperationsDeskRouteImport.update({
            id: '/desk',path: '/desk',getParentRoute: () => AuthenticatedAppOperationsRoute
          })
const AuthenticatedAppOperationsActiveWorkRoute = AuthenticatedAppOperationsActiveWorkRouteImport.update({
            id: '/active-work',path: '/active-work',getParentRoute: () => AuthenticatedAppOperationsRoute
          })
const AuthenticatedAppLaborIndexRoute = AuthenticatedAppLaborIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppLaborRoute
          })
const AuthenticatedAppLaborRatesRoute = AuthenticatedAppLaborRatesRouteImport.update({
            id: '/rates',path: '/rates',getParentRoute: () => AuthenticatedAppLaborRoute
          })
const AuthenticatedAppLaborIncentivesRoute = AuthenticatedAppLaborIncentivesRouteImport.update({
            id: '/incentives',path: '/incentives',getParentRoute: () => AuthenticatedAppLaborRoute
          })
const AuthenticatedAppLaborForecastRoute = AuthenticatedAppLaborForecastRouteImport.update({
            id: '/forecast',path: '/forecast',getParentRoute: () => AuthenticatedAppLaborRoute
          })
const AuthenticatedAppInventoryStrandedRoute = AuthenticatedAppInventoryStrandedRouteImport.update({
            id: '/stranded',path: '/stranded',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryStateRoute = AuthenticatedAppInventoryStateRouteImport.update({
            id: '/state',path: '/state',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventorySkusRoute = AuthenticatedAppInventorySkusRouteImport.update({
            id: '/skus',path: '/skus',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventorySerialsRoute = AuthenticatedAppInventorySerialsRouteImport.update({
            id: '/serials',path: '/serials',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryOnHandRoute = AuthenticatedAppInventoryOnHandRouteImport.update({
            id: '/on-hand',path: '/on-hand',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryMovementsRoute = AuthenticatedAppInventoryMovementsRouteImport.update({
            id: '/movements',path: '/movements',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryLowStockRoute = AuthenticatedAppInventoryLowStockRouteImport.update({
            id: '/low-stock',path: '/low-stock',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryLotsRoute = AuthenticatedAppInventoryLotsRouteImport.update({
            id: '/lots',path: '/lots',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryLocationsRoute = AuthenticatedAppInventoryLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryKitsRoute = AuthenticatedAppInventoryKitsRouteImport.update({
            id: '/kits',path: '/kits',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryHoldsRoute = AuthenticatedAppInventoryHoldsRouteImport.update({
            id: '/holds',path: '/holds',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryExpiringRoute = AuthenticatedAppInventoryExpiringRouteImport.update({
            id: '/expiring',path: '/expiring',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppInventoryBundlesRoute = AuthenticatedAppInventoryBundlesRouteImport.update({
            id: '/bundles',path: '/bundles',getParentRoute: () => AuthenticatedAppInventoryRoute
          })
const AuthenticatedAppImplementationIndexRoute = AuthenticatedAppImplementationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppImplementationRoute
          })
const AuthenticatedAppImplementationWorkspaceRoute = AuthenticatedAppImplementationWorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => AuthenticatedAppImplementationRoute
          })
const AuthenticatedAppImplementationLaunchKitPreviewRoute = AuthenticatedAppImplementationLaunchKitPreviewRouteImport.update({
            id: '/launch-kit-preview',path: '/launch-kit-preview',getParentRoute: () => AuthenticatedAppImplementationRoute
          })
const AuthenticatedAppForecastingIndexRoute = AuthenticatedAppForecastingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppForecastingRoute
          })
const AuthenticatedAppForecastingSuggestionsRoute = AuthenticatedAppForecastingSuggestionsRouteImport.update({
            id: '/suggestions',path: '/suggestions',getParentRoute: () => AuthenticatedAppForecastingRoute
          })
const AuthenticatedAppForecastingPoliciesRoute = AuthenticatedAppForecastingPoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => AuthenticatedAppForecastingRoute
          })
const AuthenticatedAppForecastingAlertsRoute = AuthenticatedAppForecastingAlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => AuthenticatedAppForecastingRoute
          })
const AuthenticatedAppCycleCountsIndexRoute = AuthenticatedAppCycleCountsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppCycleCountsRoute
          })
const AuthenticatedAppCycleCountsIdRoute = AuthenticatedAppCycleCountsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppCycleCountsRoute
          })
const AuthenticatedAppComplianceIndexRoute = AuthenticatedAppComplianceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppComplianceRoute
          })
const AuthenticatedAppComplianceTraceRoute = AuthenticatedAppComplianceTraceRouteImport.update({
            id: '/trace',path: '/trace',getParentRoute: () => AuthenticatedAppComplianceRoute
          })
const AuthenticatedAppComplianceRecallsRoute = AuthenticatedAppComplianceRecallsRouteImport.update({
            id: '/recalls',path: '/recalls',getParentRoute: () => AuthenticatedAppComplianceRoute
          })
const AuthenticatedAppAdminWorkflowsRoute = AuthenticatedAppAdminWorkflowsRouteImport.update({
            id: '/workflows',path: '/workflows',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminWebhooksRoute = AuthenticatedAppAdminWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminWavePoliciesRoute = AuthenticatedAppAdminWavePoliciesRouteImport.update({
            id: '/wave-policies',path: '/wave-policies',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminUsersRoute = AuthenticatedAppAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminTraceabilityRoute = AuthenticatedAppAdminTraceabilityRouteImport.update({
            id: '/traceability',path: '/traceability',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminTenantsRoute = AuthenticatedAppAdminTenantsRouteImport.update({
            id: '/tenants',path: '/tenants',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminTemplatesRoute = AuthenticatedAppAdminTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminStatusRoute = AuthenticatedAppAdminStatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminSlottingRoute = AuthenticatedAppAdminSlottingRouteImport.update({
            id: '/slotting',path: '/slotting',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminSlackRoute = AuthenticatedAppAdminSlackRouteImport.update({
            id: '/slack',path: '/slack',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminShippingPoliciesRoute = AuthenticatedAppAdminShippingPoliciesRouteImport.update({
            id: '/shipping-policies',path: '/shipping-policies',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminRulesRoute = AuthenticatedAppAdminRulesRouteImport.update({
            id: '/rules',path: '/rules',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminRoutingRoute = AuthenticatedAppAdminRoutingRouteImport.update({
            id: '/routing',path: '/routing',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminReturnsConfigRoute = AuthenticatedAppAdminReturnsConfigRouteImport.update({
            id: '/returns-config',path: '/returns-config',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminReplenishmentRoute = AuthenticatedAppAdminReplenishmentRouteImport.update({
            id: '/replenishment',path: '/replenishment',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminReconciliationRoute = AuthenticatedAppAdminReconciliationRouteImport.update({
            id: '/reconciliation',path: '/reconciliation',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminReceivingPoliciesRoute = AuthenticatedAppAdminReceivingPoliciesRouteImport.update({
            id: '/receiving-policies',path: '/receiving-policies',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminPutawayRoute = AuthenticatedAppAdminPutawayRouteImport.update({
            id: '/putaway',path: '/putaway',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminPrintQueueRoute = AuthenticatedAppAdminPrintQueueRouteImport.update({
            id: '/print-queue',path: '/print-queue',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminPortalReportsRoute = AuthenticatedAppAdminPortalReportsRouteImport.update({
            id: '/portal-reports',path: '/portal-reports',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminPolicyParityRoute = AuthenticatedAppAdminPolicyParityRouteImport.update({
            id: '/policy-parity',path: '/policy-parity',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminOperationalSignalsRoute = AuthenticatedAppAdminOperationalSignalsRouteImport.update({
            id: '/operational-signals',path: '/operational-signals',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminOncallRoute = AuthenticatedAppAdminOncallRouteImport.update({
            id: '/oncall',path: '/oncall',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminOnboardingRoute = AuthenticatedAppAdminOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminObservabilityRoute = AuthenticatedAppAdminObservabilityRouteImport.update({
            id: '/observability',path: '/observability',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminNotificationsRoute = AuthenticatedAppAdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminManifestsRoute = AuthenticatedAppAdminManifestsRouteImport.update({
            id: '/manifests',path: '/manifests',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminJobsRoute = AuthenticatedAppAdminJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminInventoryPlanningPoliciesRoute = AuthenticatedAppAdminInventoryPlanningPoliciesRouteImport.update({
            id: '/inventory-planning-policies',path: '/inventory-planning-policies',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminInventoryAdjustmentsRoute = AuthenticatedAppAdminInventoryAdjustmentsRouteImport.update({
            id: '/inventory-adjustments',path: '/inventory-adjustments',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminHoldRulesRoute = AuthenticatedAppAdminHoldRulesRouteImport.update({
            id: '/hold-rules',path: '/hold-rules',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminHoldCreationRoute = AuthenticatedAppAdminHoldCreationRouteImport.update({
            id: '/hold-creation',path: '/hold-creation',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminHardwareRoute = AuthenticatedAppAdminHardwareRouteImport.update({
            id: '/hardware',path: '/hardware',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminGoogleRoute = AuthenticatedAppAdminGoogleRouteImport.update({
            id: '/google',path: '/google',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminFulfillmentRoute = AuthenticatedAppAdminFulfillmentRouteImport.update({
            id: '/fulfillment',path: '/fulfillment',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminFreightRoute = AuthenticatedAppAdminFreightRouteImport.update({
            id: '/freight',path: '/freight',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminFacilitiesRoute = AuthenticatedAppAdminFacilitiesRouteImport.update({
            id: '/facilities',path: '/facilities',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminExchangeRunsRoute = AuthenticatedAppAdminExchangeRunsRouteImport.update({
            id: '/exchange-runs',path: '/exchange-runs',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminEnterpriseRoute = AuthenticatedAppAdminEnterpriseRouteImport.update({
            id: '/enterprise',path: '/enterprise',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminEdiRoute = AuthenticatedAppAdminEdiRouteImport.update({
            id: '/edi',path: '/edi',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminDevicesRoute = AuthenticatedAppAdminDevicesRouteImport.update({
            id: '/devices',path: '/devices',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminDeliveryCommitmentPoliciesRoute = AuthenticatedAppAdminDeliveryCommitmentPoliciesRouteImport.update({
            id: '/delivery-commitment-policies',path: '/delivery-commitment-policies',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCycleCountSchedulesRoute = AuthenticatedAppAdminCycleCountSchedulesRouteImport.update({
            id: '/cycle-count-schedules',path: '/cycle-count-schedules',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCustomerFacilitiesRoute = AuthenticatedAppAdminCustomerFacilitiesRouteImport.update({
            id: '/customer-facilities',path: '/customer-facilities',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCustomFieldsRoute = AuthenticatedAppAdminCustomFieldsRouteImport.update({
            id: '/custom-fields',path: '/custom-fields',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCostToServeRoute = AuthenticatedAppAdminCostToServeRouteImport.update({
            id: '/cost-to-serve',path: '/cost-to-serve',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminConsumablesRoute = AuthenticatedAppAdminConsumablesRouteImport.update({
            id: '/consumables',path: '/consumables',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminComplianceRoute = AuthenticatedAppAdminComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCarriersRoute = AuthenticatedAppAdminCarriersRouteImport.update({
            id: '/carriers',path: '/carriers',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminBlueprintsRoute = AuthenticatedAppAdminBlueprintsRouteImport.update({
            id: '/blueprints',path: '/blueprints',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminBillingPlatformRoute = AuthenticatedAppAdminBillingPlatformRouteImport.update({
            id: '/billing-platform',path: '/billing-platform',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminBillingRoute = AuthenticatedAppAdminBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminAuditRoute = AuthenticatedAppAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminApiKeysRoute = AuthenticatedAppAdminApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminAlertsRoute = AuthenticatedAppAdminAlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppManifestsManifestIdPrintRoute = AuthenticatedAppManifestsManifestIdPrintRouteImport.update({
            id: '/manifests/$manifestId/print',path: '/manifests/$manifestId/print',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingCustomersCustomerIdRoute = AuthenticatedAppBillingCustomersCustomerIdRouteImport.update({
            id: '/billing/customers/$customerId',path: '/billing/customers/$customerId',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingInvoiceIdPrintRoute = AuthenticatedAppBillingInvoiceIdPrintRouteImport.update({
            id: '/billing/$invoiceId/print',path: '/billing/$invoiceId/print',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPackOrderIdPackingSlipRoute = AuthenticatedAppPackOrderIdPackingSlipRouteImport.update({
            id: '/packing-slip',path: '/packing-slip',getParentRoute: () => AuthenticatedAppPackOrderIdRoute
          })
const AuthenticatedAppShipmentsShipmentIdIndexRoute = AuthenticatedAppShipmentsShipmentIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppShipmentsShipmentIdRoute
          })
const AuthenticatedAppShipmentsShipmentIdPalletLabelsRoute = AuthenticatedAppShipmentsShipmentIdPalletLabelsRouteImport.update({
            id: '/pallet-labels',path: '/pallet-labels',getParentRoute: () => AuthenticatedAppShipmentsShipmentIdRoute
          })
const AuthenticatedAppShipmentsShipmentIdBolRoute = AuthenticatedAppShipmentsShipmentIdBolRouteImport.update({
            id: '/bol',path: '/bol',getParentRoute: () => AuthenticatedAppShipmentsShipmentIdRoute
          })
const AuthenticatedAppRfReturnsRmaIdRoute = AuthenticatedAppRfReturnsRmaIdRouteImport.update({
            id: '/$rmaId',path: '/$rmaId',getParentRoute: () => AuthenticatedAppRfReturnsRoute
          })
const AuthenticatedAppRfReceivingAsnIdRoute = AuthenticatedAppRfReceivingAsnIdRouteImport.update({
            id: '/$asnId',path: '/$asnId',getParentRoute: () => AuthenticatedAppRfReceivingRoute
          })
const AuthenticatedAppRfCycleCountIdRoute = AuthenticatedAppRfCycleCountIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppRfCycleCountRoute
          })
const AuthenticatedAppPickSessionSessionIdRoute = AuthenticatedAppPickSessionSessionIdRouteImport.update({
            id: '/session/$sessionId',path: '/session/$sessionId',getParentRoute: () => AuthenticatedAppPickRoute
          })
const AuthenticatedAppPickWavesIndexRoute = AuthenticatedAppPickWavesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppPickWavesRoute
          })
const AuthenticatedAppPickWavesWaveIdRoute = AuthenticatedAppPickWavesWaveIdRouteImport.update({
            id: '/$waveId',path: '/$waveId',getParentRoute: () => AuthenticatedAppPickWavesRoute
          })
const AuthenticatedAppOrdersOrderIdPackingSlipRoute = AuthenticatedAppOrdersOrderIdPackingSlipRouteImport.update({
            id: '/packing-slip',path: '/packing-slip',getParentRoute: () => AuthenticatedAppOrdersOrderIdRoute
          })
const AuthenticatedAppInventoryLocationsLocationIdRoute = AuthenticatedAppInventoryLocationsLocationIdRouteImport.update({
            id: '/$locationId',path: '/$locationId',getParentRoute: () => AuthenticatedAppInventoryLocationsRoute
          })
const AuthenticatedAppInventoryKitsIndexRoute = AuthenticatedAppInventoryKitsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppInventoryKitsRoute
          })
const AuthenticatedAppInventoryKitsWorkOrderIdRoute = AuthenticatedAppInventoryKitsWorkOrderIdRouteImport.update({
            id: '/$workOrderId',path: '/$workOrderId',getParentRoute: () => AuthenticatedAppInventoryKitsRoute
          })
const AuthenticatedAppImplementationWorkspaceIndexRoute = AuthenticatedAppImplementationWorkspaceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppImplementationWorkspaceRoute
          })
const AuthenticatedAppImplementationWorkspaceValidationRoute = AuthenticatedAppImplementationWorkspaceValidationRouteImport.update({
            id: '/validation',path: '/validation',getParentRoute: () => AuthenticatedAppImplementationWorkspaceRoute
          })
const AuthenticatedAppImplementationWorkspaceOperationsRoute = AuthenticatedAppImplementationWorkspaceOperationsRouteImport.update({
            id: '/operations',path: '/operations',getParentRoute: () => AuthenticatedAppImplementationWorkspaceRoute
          })
const AuthenticatedAppImplementationWorkspaceFoundationRoute = AuthenticatedAppImplementationWorkspaceFoundationRouteImport.update({
            id: '/foundation',path: '/foundation',getParentRoute: () => AuthenticatedAppImplementationWorkspaceRoute
          })
const AuthenticatedAppImplementationWorkspaceDataRoute = AuthenticatedAppImplementationWorkspaceDataRouteImport.update({
            id: '/data',path: '/data',getParentRoute: () => AuthenticatedAppImplementationWorkspaceRoute
          })
const AuthenticatedAppForecastingSkuSkuIdRoute = AuthenticatedAppForecastingSkuSkuIdRouteImport.update({
            id: '/sku/$skuId',path: '/sku/$skuId',getParentRoute: () => AuthenticatedAppForecastingRoute
          })
const AuthenticatedAppComplianceRecallsIndexRoute = AuthenticatedAppComplianceRecallsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppComplianceRecallsRoute
          })
const AuthenticatedAppComplianceRecallsIdRoute = AuthenticatedAppComplianceRecallsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAppComplianceRecallsRoute
          })
const AuthenticatedAppAdminIntegrationsIndexRoute = AuthenticatedAppAdminIntegrationsIndexRouteImport.update({
            id: '/integrations/',path: '/integrations/',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCustomersIndexRoute = AuthenticatedAppAdminCustomersIndexRouteImport.update({
            id: '/customers/',path: '/customers/',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminConnectionsIndexRoute = AuthenticatedAppAdminConnectionsIndexRouteImport.update({
            id: '/connections/',path: '/connections/',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminIntegrationsConnectionIdRoute = AuthenticatedAppAdminIntegrationsConnectionIdRouteImport.update({
            id: '/integrations/$connectionId',path: '/integrations/$connectionId',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminConnectionsConnectionIdRoute = AuthenticatedAppAdminConnectionsConnectionIdRouteImport.update({
            id: '/connections/$connectionId',path: '/connections/$connectionId',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminPortalReportsIndexRoute = AuthenticatedAppAdminPortalReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppAdminPortalReportsRoute
          })
const AuthenticatedAppAdminPortalReportsAccessRoute = AuthenticatedAppAdminPortalReportsAccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => AuthenticatedAppAdminPortalReportsRoute
          })
const AuthenticatedAppAdminHoldRulesAdvancedRoute = AuthenticatedAppAdminHoldRulesAdvancedRouteImport.update({
            id: '/advanced',path: '/advanced',getParentRoute: () => AuthenticatedAppAdminHoldRulesRoute
          })
const AuthenticatedAppAdminHoldCreationAdvancedRoute = AuthenticatedAppAdminHoldCreationAdvancedRouteImport.update({
            id: '/advanced',path: '/advanced',getParentRoute: () => AuthenticatedAppAdminHoldCreationRoute
          })
const AuthenticatedAppAdminExchangeRunsRunIdRoute = AuthenticatedAppAdminExchangeRunsRunIdRouteImport.update({
            id: '/$runId',path: '/$runId',getParentRoute: () => AuthenticatedAppAdminExchangeRunsRoute
          })
const AuthenticatedAppShipmentsShipmentIdBolPrintRoute = AuthenticatedAppShipmentsShipmentIdBolPrintRouteImport.update({
            id: '/print',path: '/print',getParentRoute: () => AuthenticatedAppShipmentsShipmentIdBolRoute
          })
const AuthenticatedAppAdminIntegrationsCartroverConnectionIdRoute = AuthenticatedAppAdminIntegrationsCartroverConnectionIdRouteImport.update({
            id: '/integrations/cartrover/$connectionId',path: '/integrations/cartrover/$connectionId',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCustomersCustomerIdIntegrationsRoute = AuthenticatedAppAdminCustomersCustomerIdIntegrationsRouteImport.update({
            id: '/customers/$customerId/integrations',path: '/customers/$customerId/integrations',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminCustomersCustomerIdCarriersRoute = AuthenticatedAppAdminCustomersCustomerIdCarriersRouteImport.update({
            id: '/customers/$customerId/carriers',path: '/customers/$customerId/carriers',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminBillingPlatformContractsCustomerIdRoute = AuthenticatedAppAdminBillingPlatformContractsCustomerIdRouteImport.update({
            id: '/contracts/$customerId',path: '/contracts/$customerId',getParentRoute: () => AuthenticatedAppAdminBillingPlatformRoute
          })





const AuthenticatedAppAdminBillingPlatformRouteChildren = {
  AuthenticatedAppAdminBillingPlatformContractsCustomerIdRoute: AuthenticatedAppAdminBillingPlatformContractsCustomerIdRoute
}

const AuthenticatedAppAdminBillingPlatformRouteWithChildren = AuthenticatedAppAdminBillingPlatformRoute._addFileChildren(AuthenticatedAppAdminBillingPlatformRouteChildren)




const AuthenticatedAppAdminExchangeRunsRouteChildren = {
  AuthenticatedAppAdminExchangeRunsRunIdRoute: AuthenticatedAppAdminExchangeRunsRunIdRoute
}

const AuthenticatedAppAdminExchangeRunsRouteWithChildren = AuthenticatedAppAdminExchangeRunsRoute._addFileChildren(AuthenticatedAppAdminExchangeRunsRouteChildren)




const AuthenticatedAppAdminHoldCreationRouteChildren = {
  AuthenticatedAppAdminHoldCreationAdvancedRoute: AuthenticatedAppAdminHoldCreationAdvancedRoute
}

const AuthenticatedAppAdminHoldCreationRouteWithChildren = AuthenticatedAppAdminHoldCreationRoute._addFileChildren(AuthenticatedAppAdminHoldCreationRouteChildren)




const AuthenticatedAppAdminHoldRulesRouteChildren = {
  AuthenticatedAppAdminHoldRulesAdvancedRoute: AuthenticatedAppAdminHoldRulesAdvancedRoute
}

const AuthenticatedAppAdminHoldRulesRouteWithChildren = AuthenticatedAppAdminHoldRulesRoute._addFileChildren(AuthenticatedAppAdminHoldRulesRouteChildren)




const AuthenticatedAppAdminPortalReportsRouteChildren = {
  AuthenticatedAppAdminPortalReportsAccessRoute: AuthenticatedAppAdminPortalReportsAccessRoute,AuthenticatedAppAdminPortalReportsIndexRoute: AuthenticatedAppAdminPortalReportsIndexRoute
}

const AuthenticatedAppAdminPortalReportsRouteWithChildren = AuthenticatedAppAdminPortalReportsRoute._addFileChildren(AuthenticatedAppAdminPortalReportsRouteChildren)



const AuthenticatedAppAdminRouteChildren = {
  AuthenticatedAppAdminAlertsRoute: AuthenticatedAppAdminAlertsRoute,AuthenticatedAppAdminApiKeysRoute: AuthenticatedAppAdminApiKeysRoute,AuthenticatedAppAdminAuditRoute: AuthenticatedAppAdminAuditRoute,AuthenticatedAppAdminBillingRoute: AuthenticatedAppAdminBillingRoute,AuthenticatedAppAdminBillingPlatformRoute: AuthenticatedAppAdminBillingPlatformRouteWithChildren,AuthenticatedAppAdminBlueprintsRoute: AuthenticatedAppAdminBlueprintsRoute,AuthenticatedAppAdminCarriersRoute: AuthenticatedAppAdminCarriersRoute,AuthenticatedAppAdminComplianceRoute: AuthenticatedAppAdminComplianceRoute,AuthenticatedAppAdminConsumablesRoute: AuthenticatedAppAdminConsumablesRoute,AuthenticatedAppAdminCostToServeRoute: AuthenticatedAppAdminCostToServeRoute,AuthenticatedAppAdminCustomFieldsRoute: AuthenticatedAppAdminCustomFieldsRoute,AuthenticatedAppAdminCustomerFacilitiesRoute: AuthenticatedAppAdminCustomerFacilitiesRoute,AuthenticatedAppAdminCycleCountSchedulesRoute: AuthenticatedAppAdminCycleCountSchedulesRoute,AuthenticatedAppAdminDeliveryCommitmentPoliciesRoute: AuthenticatedAppAdminDeliveryCommitmentPoliciesRoute,AuthenticatedAppAdminDevicesRoute: AuthenticatedAppAdminDevicesRoute,AuthenticatedAppAdminEdiRoute: AuthenticatedAppAdminEdiRoute,AuthenticatedAppAdminEnterpriseRoute: AuthenticatedAppAdminEnterpriseRoute,AuthenticatedAppAdminExchangeRunsRoute: AuthenticatedAppAdminExchangeRunsRouteWithChildren,AuthenticatedAppAdminFacilitiesRoute: AuthenticatedAppAdminFacilitiesRoute,AuthenticatedAppAdminFreightRoute: AuthenticatedAppAdminFreightRoute,AuthenticatedAppAdminFulfillmentRoute: AuthenticatedAppAdminFulfillmentRoute,AuthenticatedAppAdminGoogleRoute: AuthenticatedAppAdminGoogleRoute,AuthenticatedAppAdminHardwareRoute: AuthenticatedAppAdminHardwareRoute,AuthenticatedAppAdminHoldCreationRoute: AuthenticatedAppAdminHoldCreationRouteWithChildren,AuthenticatedAppAdminHoldRulesRoute: AuthenticatedAppAdminHoldRulesRouteWithChildren,AuthenticatedAppAdminInventoryAdjustmentsRoute: AuthenticatedAppAdminInventoryAdjustmentsRoute,AuthenticatedAppAdminInventoryPlanningPoliciesRoute: AuthenticatedAppAdminInventoryPlanningPoliciesRoute,AuthenticatedAppAdminJobsRoute: AuthenticatedAppAdminJobsRoute,AuthenticatedAppAdminManifestsRoute: AuthenticatedAppAdminManifestsRoute,AuthenticatedAppAdminNotificationsRoute: AuthenticatedAppAdminNotificationsRoute,AuthenticatedAppAdminObservabilityRoute: AuthenticatedAppAdminObservabilityRoute,AuthenticatedAppAdminOnboardingRoute: AuthenticatedAppAdminOnboardingRoute,AuthenticatedAppAdminOncallRoute: AuthenticatedAppAdminOncallRoute,AuthenticatedAppAdminOperationalSignalsRoute: AuthenticatedAppAdminOperationalSignalsRoute,AuthenticatedAppAdminPolicyParityRoute: AuthenticatedAppAdminPolicyParityRoute,AuthenticatedAppAdminPortalReportsRoute: AuthenticatedAppAdminPortalReportsRouteWithChildren,AuthenticatedAppAdminPrintQueueRoute: AuthenticatedAppAdminPrintQueueRoute,AuthenticatedAppAdminPutawayRoute: AuthenticatedAppAdminPutawayRoute,AuthenticatedAppAdminReceivingPoliciesRoute: AuthenticatedAppAdminReceivingPoliciesRoute,AuthenticatedAppAdminReconciliationRoute: AuthenticatedAppAdminReconciliationRoute,AuthenticatedAppAdminReplenishmentRoute: AuthenticatedAppAdminReplenishmentRoute,AuthenticatedAppAdminReturnsConfigRoute: AuthenticatedAppAdminReturnsConfigRoute,AuthenticatedAppAdminRoutingRoute: AuthenticatedAppAdminRoutingRoute,AuthenticatedAppAdminRulesRoute: AuthenticatedAppAdminRulesRoute,AuthenticatedAppAdminShippingPoliciesRoute: AuthenticatedAppAdminShippingPoliciesRoute,AuthenticatedAppAdminSlackRoute: AuthenticatedAppAdminSlackRoute,AuthenticatedAppAdminSlottingRoute: AuthenticatedAppAdminSlottingRoute,AuthenticatedAppAdminStatusRoute: AuthenticatedAppAdminStatusRoute,AuthenticatedAppAdminTemplatesRoute: AuthenticatedAppAdminTemplatesRoute,AuthenticatedAppAdminTenantsRoute: AuthenticatedAppAdminTenantsRoute,AuthenticatedAppAdminTraceabilityRoute: AuthenticatedAppAdminTraceabilityRoute,AuthenticatedAppAdminUsersRoute: AuthenticatedAppAdminUsersRoute,AuthenticatedAppAdminWavePoliciesRoute: AuthenticatedAppAdminWavePoliciesRoute,AuthenticatedAppAdminWebhooksRoute: AuthenticatedAppAdminWebhooksRoute,AuthenticatedAppAdminWorkflowsRoute: AuthenticatedAppAdminWorkflowsRoute,AuthenticatedAppAdminConnectionsConnectionIdRoute: AuthenticatedAppAdminConnectionsConnectionIdRoute,AuthenticatedAppAdminIntegrationsConnectionIdRoute: AuthenticatedAppAdminIntegrationsConnectionIdRoute,AuthenticatedAppAdminConnectionsIndexRoute: AuthenticatedAppAdminConnectionsIndexRoute,AuthenticatedAppAdminCustomersIndexRoute: AuthenticatedAppAdminCustomersIndexRoute,AuthenticatedAppAdminIntegrationsIndexRoute: AuthenticatedAppAdminIntegrationsIndexRoute,AuthenticatedAppAdminCustomersCustomerIdCarriersRoute: AuthenticatedAppAdminCustomersCustomerIdCarriersRoute,AuthenticatedAppAdminCustomersCustomerIdIntegrationsRoute: AuthenticatedAppAdminCustomersCustomerIdIntegrationsRoute,AuthenticatedAppAdminIntegrationsCartroverConnectionIdRoute: AuthenticatedAppAdminIntegrationsCartroverConnectionIdRoute
}

const AuthenticatedAppAdminRouteWithChildren = AuthenticatedAppAdminRoute._addFileChildren(AuthenticatedAppAdminRouteChildren)




const AuthenticatedAppComplianceRecallsRouteChildren = {
  AuthenticatedAppComplianceRecallsIdRoute: AuthenticatedAppComplianceRecallsIdRoute,AuthenticatedAppComplianceRecallsIndexRoute: AuthenticatedAppComplianceRecallsIndexRoute
}

const AuthenticatedAppComplianceRecallsRouteWithChildren = AuthenticatedAppComplianceRecallsRoute._addFileChildren(AuthenticatedAppComplianceRecallsRouteChildren)



const AuthenticatedAppComplianceRouteChildren = {
  AuthenticatedAppComplianceRecallsRoute: AuthenticatedAppComplianceRecallsRouteWithChildren,AuthenticatedAppComplianceTraceRoute: AuthenticatedAppComplianceTraceRoute,AuthenticatedAppComplianceIndexRoute: AuthenticatedAppComplianceIndexRoute
}

const AuthenticatedAppComplianceRouteWithChildren = AuthenticatedAppComplianceRoute._addFileChildren(AuthenticatedAppComplianceRouteChildren)




const AuthenticatedAppCycleCountsRouteChildren = {
  AuthenticatedAppCycleCountsIdRoute: AuthenticatedAppCycleCountsIdRoute,AuthenticatedAppCycleCountsIndexRoute: AuthenticatedAppCycleCountsIndexRoute
}

const AuthenticatedAppCycleCountsRouteWithChildren = AuthenticatedAppCycleCountsRoute._addFileChildren(AuthenticatedAppCycleCountsRouteChildren)




const AuthenticatedAppForecastingRouteChildren = {
  AuthenticatedAppForecastingAlertsRoute: AuthenticatedAppForecastingAlertsRoute,AuthenticatedAppForecastingPoliciesRoute: AuthenticatedAppForecastingPoliciesRoute,AuthenticatedAppForecastingSuggestionsRoute: AuthenticatedAppForecastingSuggestionsRoute,AuthenticatedAppForecastingIndexRoute: AuthenticatedAppForecastingIndexRoute,AuthenticatedAppForecastingSkuSkuIdRoute: AuthenticatedAppForecastingSkuSkuIdRoute
}

const AuthenticatedAppForecastingRouteWithChildren = AuthenticatedAppForecastingRoute._addFileChildren(AuthenticatedAppForecastingRouteChildren)




const AuthenticatedAppImplementationWorkspaceRouteChildren = {
  AuthenticatedAppImplementationWorkspaceDataRoute: AuthenticatedAppImplementationWorkspaceDataRoute,AuthenticatedAppImplementationWorkspaceFoundationRoute: AuthenticatedAppImplementationWorkspaceFoundationRoute,AuthenticatedAppImplementationWorkspaceOperationsRoute: AuthenticatedAppImplementationWorkspaceOperationsRoute,AuthenticatedAppImplementationWorkspaceValidationRoute: AuthenticatedAppImplementationWorkspaceValidationRoute,AuthenticatedAppImplementationWorkspaceIndexRoute: AuthenticatedAppImplementationWorkspaceIndexRoute
}

const AuthenticatedAppImplementationWorkspaceRouteWithChildren = AuthenticatedAppImplementationWorkspaceRoute._addFileChildren(AuthenticatedAppImplementationWorkspaceRouteChildren)



const AuthenticatedAppImplementationRouteChildren = {
  AuthenticatedAppImplementationLaunchKitPreviewRoute: AuthenticatedAppImplementationLaunchKitPreviewRoute,AuthenticatedAppImplementationWorkspaceRoute: AuthenticatedAppImplementationWorkspaceRouteWithChildren,AuthenticatedAppImplementationIndexRoute: AuthenticatedAppImplementationIndexRoute
}

const AuthenticatedAppImplementationRouteWithChildren = AuthenticatedAppImplementationRoute._addFileChildren(AuthenticatedAppImplementationRouteChildren)




const AuthenticatedAppInventoryKitsRouteChildren = {
  AuthenticatedAppInventoryKitsWorkOrderIdRoute: AuthenticatedAppInventoryKitsWorkOrderIdRoute,AuthenticatedAppInventoryKitsIndexRoute: AuthenticatedAppInventoryKitsIndexRoute
}

const AuthenticatedAppInventoryKitsRouteWithChildren = AuthenticatedAppInventoryKitsRoute._addFileChildren(AuthenticatedAppInventoryKitsRouteChildren)




const AuthenticatedAppInventoryLocationsRouteChildren = {
  AuthenticatedAppInventoryLocationsLocationIdRoute: AuthenticatedAppInventoryLocationsLocationIdRoute
}

const AuthenticatedAppInventoryLocationsRouteWithChildren = AuthenticatedAppInventoryLocationsRoute._addFileChildren(AuthenticatedAppInventoryLocationsRouteChildren)



const AuthenticatedAppInventoryRouteChildren = {
  AuthenticatedAppInventoryBundlesRoute: AuthenticatedAppInventoryBundlesRoute,AuthenticatedAppInventoryExpiringRoute: AuthenticatedAppInventoryExpiringRoute,AuthenticatedAppInventoryHoldsRoute: AuthenticatedAppInventoryHoldsRoute,AuthenticatedAppInventoryKitsRoute: AuthenticatedAppInventoryKitsRouteWithChildren,AuthenticatedAppInventoryLocationsRoute: AuthenticatedAppInventoryLocationsRouteWithChildren,AuthenticatedAppInventoryLotsRoute: AuthenticatedAppInventoryLotsRoute,AuthenticatedAppInventoryLowStockRoute: AuthenticatedAppInventoryLowStockRoute,AuthenticatedAppInventoryMovementsRoute: AuthenticatedAppInventoryMovementsRoute,AuthenticatedAppInventoryOnHandRoute: AuthenticatedAppInventoryOnHandRoute,AuthenticatedAppInventorySerialsRoute: AuthenticatedAppInventorySerialsRoute,AuthenticatedAppInventorySkusRoute: AuthenticatedAppInventorySkusRoute,AuthenticatedAppInventoryStateRoute: AuthenticatedAppInventoryStateRoute,AuthenticatedAppInventoryStrandedRoute: AuthenticatedAppInventoryStrandedRoute
}

const AuthenticatedAppInventoryRouteWithChildren = AuthenticatedAppInventoryRoute._addFileChildren(AuthenticatedAppInventoryRouteChildren)




const AuthenticatedAppLaborRouteChildren = {
  AuthenticatedAppLaborForecastRoute: AuthenticatedAppLaborForecastRoute,AuthenticatedAppLaborIncentivesRoute: AuthenticatedAppLaborIncentivesRoute,AuthenticatedAppLaborRatesRoute: AuthenticatedAppLaborRatesRoute,AuthenticatedAppLaborIndexRoute: AuthenticatedAppLaborIndexRoute
}

const AuthenticatedAppLaborRouteWithChildren = AuthenticatedAppLaborRoute._addFileChildren(AuthenticatedAppLaborRouteChildren)




const AuthenticatedAppOperationsRouteChildren = {
  AuthenticatedAppOperationsActiveWorkRoute: AuthenticatedAppOperationsActiveWorkRoute,AuthenticatedAppOperationsDeskRoute: AuthenticatedAppOperationsDeskRoute,AuthenticatedAppOperationsIndexRoute: AuthenticatedAppOperationsIndexRoute
}

const AuthenticatedAppOperationsRouteWithChildren = AuthenticatedAppOperationsRoute._addFileChildren(AuthenticatedAppOperationsRouteChildren)




const AuthenticatedAppOrdersOrderIdRouteChildren = {
  AuthenticatedAppOrdersOrderIdPackingSlipRoute: AuthenticatedAppOrdersOrderIdPackingSlipRoute
}

const AuthenticatedAppOrdersOrderIdRouteWithChildren = AuthenticatedAppOrdersOrderIdRoute._addFileChildren(AuthenticatedAppOrdersOrderIdRouteChildren)



const AuthenticatedAppOrdersRouteChildren = {
  AuthenticatedAppOrdersOrderIdRoute: AuthenticatedAppOrdersOrderIdRouteWithChildren,AuthenticatedAppOrdersNewRoute: AuthenticatedAppOrdersNewRoute,AuthenticatedAppOrdersIndexRoute: AuthenticatedAppOrdersIndexRoute
}

const AuthenticatedAppOrdersRouteWithChildren = AuthenticatedAppOrdersRoute._addFileChildren(AuthenticatedAppOrdersRouteChildren)




const AuthenticatedAppPickWavesRouteChildren = {
  AuthenticatedAppPickWavesWaveIdRoute: AuthenticatedAppPickWavesWaveIdRoute,AuthenticatedAppPickWavesIndexRoute: AuthenticatedAppPickWavesIndexRoute
}

const AuthenticatedAppPickWavesRouteWithChildren = AuthenticatedAppPickWavesRoute._addFileChildren(AuthenticatedAppPickWavesRouteChildren)



const AuthenticatedAppPickRouteChildren = {
  AuthenticatedAppPickWavesRoute: AuthenticatedAppPickWavesRouteWithChildren,AuthenticatedAppPickIndexRoute: AuthenticatedAppPickIndexRoute,AuthenticatedAppPickSessionSessionIdRoute: AuthenticatedAppPickSessionSessionIdRoute
}

const AuthenticatedAppPickRouteWithChildren = AuthenticatedAppPickRoute._addFileChildren(AuthenticatedAppPickRouteChildren)




const AuthenticatedAppPlaybookRouteChildren = {
  AuthenticatedAppPlaybookSplatRoute: AuthenticatedAppPlaybookSplatRoute,AuthenticatedAppPlaybookSearchRoute: AuthenticatedAppPlaybookSearchRoute,AuthenticatedAppPlaybookIndexRoute: AuthenticatedAppPlaybookIndexRoute
}

const AuthenticatedAppPlaybookRouteWithChildren = AuthenticatedAppPlaybookRoute._addFileChildren(AuthenticatedAppPlaybookRouteChildren)




const AuthenticatedAppPoliciesRouteChildren = {
  AuthenticatedAppPoliciesPolicyIdRoute: AuthenticatedAppPoliciesPolicyIdRoute,AuthenticatedAppPoliciesLibraryRoute: AuthenticatedAppPoliciesLibraryRoute,AuthenticatedAppPoliciesPrototypeRoute: AuthenticatedAppPoliciesPrototypeRoute,AuthenticatedAppPoliciesIndexRoute: AuthenticatedAppPoliciesIndexRoute
}

const AuthenticatedAppPoliciesRouteWithChildren = AuthenticatedAppPoliciesRoute._addFileChildren(AuthenticatedAppPoliciesRouteChildren)




const AuthenticatedAppReceivingRouteChildren = {
  AuthenticatedAppReceivingAsnIdRoute: AuthenticatedAppReceivingAsnIdRoute,AuthenticatedAppReceivingScorecardRoute: AuthenticatedAppReceivingScorecardRoute,AuthenticatedAppReceivingIndexRoute: AuthenticatedAppReceivingIndexRoute
}

const AuthenticatedAppReceivingRouteWithChildren = AuthenticatedAppReceivingRoute._addFileChildren(AuthenticatedAppReceivingRouteChildren)




const AuthenticatedAppReportsRouteChildren = {
  AuthenticatedAppReportsBillingRoute: AuthenticatedAppReportsBillingRoute,AuthenticatedAppReportsBuilderRoute: AuthenticatedAppReportsBuilderRoute,AuthenticatedAppReportsInventoryRoute: AuthenticatedAppReportsInventoryRoute,AuthenticatedAppReportsReceivingRoute: AuthenticatedAppReportsReceivingRoute,AuthenticatedAppReportsShippingRoute: AuthenticatedAppReportsShippingRoute,AuthenticatedAppReportsWarehouseRoute: AuthenticatedAppReportsWarehouseRoute,AuthenticatedAppReportsIndexRoute: AuthenticatedAppReportsIndexRoute
}

const AuthenticatedAppReportsRouteWithChildren = AuthenticatedAppReportsRoute._addFileChildren(AuthenticatedAppReportsRouteChildren)




const AuthenticatedAppRfCycleCountRouteChildren = {
  AuthenticatedAppRfCycleCountIdRoute: AuthenticatedAppRfCycleCountIdRoute
}

const AuthenticatedAppRfCycleCountRouteWithChildren = AuthenticatedAppRfCycleCountRoute._addFileChildren(AuthenticatedAppRfCycleCountRouteChildren)




const AuthenticatedAppRfReceivingRouteChildren = {
  AuthenticatedAppRfReceivingAsnIdRoute: AuthenticatedAppRfReceivingAsnIdRoute
}

const AuthenticatedAppRfReceivingRouteWithChildren = AuthenticatedAppRfReceivingRoute._addFileChildren(AuthenticatedAppRfReceivingRouteChildren)




const AuthenticatedAppRfReturnsRouteChildren = {
  AuthenticatedAppRfReturnsRmaIdRoute: AuthenticatedAppRfReturnsRmaIdRoute
}

const AuthenticatedAppRfReturnsRouteWithChildren = AuthenticatedAppRfReturnsRoute._addFileChildren(AuthenticatedAppRfReturnsRouteChildren)



const AuthenticatedAppRfRouteChildren = {
  AuthenticatedAppRfCycleCountRoute: AuthenticatedAppRfCycleCountRouteWithChildren,AuthenticatedAppRfPickRoute: AuthenticatedAppRfPickRoute,AuthenticatedAppRfPutawayRoute: AuthenticatedAppRfPutawayRoute,AuthenticatedAppRfReceivingRoute: AuthenticatedAppRfReceivingRouteWithChildren,AuthenticatedAppRfReplenishmentRoute: AuthenticatedAppRfReplenishmentRoute,AuthenticatedAppRfReturnsRoute: AuthenticatedAppRfReturnsRouteWithChildren,AuthenticatedAppRfTransfersRoute: AuthenticatedAppRfTransfersRoute,AuthenticatedAppRfIndexRoute: AuthenticatedAppRfIndexRoute
}

const AuthenticatedAppRfRouteWithChildren = AuthenticatedAppRfRoute._addFileChildren(AuthenticatedAppRfRouteChildren)




const AuthenticatedAppShipmentsShipmentIdBolRouteChildren = {
  AuthenticatedAppShipmentsShipmentIdBolPrintRoute: AuthenticatedAppShipmentsShipmentIdBolPrintRoute
}

const AuthenticatedAppShipmentsShipmentIdBolRouteWithChildren = AuthenticatedAppShipmentsShipmentIdBolRoute._addFileChildren(AuthenticatedAppShipmentsShipmentIdBolRouteChildren)



const AuthenticatedAppShipmentsShipmentIdRouteChildren = {
  AuthenticatedAppShipmentsShipmentIdBolRoute: AuthenticatedAppShipmentsShipmentIdBolRouteWithChildren,AuthenticatedAppShipmentsShipmentIdPalletLabelsRoute: AuthenticatedAppShipmentsShipmentIdPalletLabelsRoute,AuthenticatedAppShipmentsShipmentIdIndexRoute: AuthenticatedAppShipmentsShipmentIdIndexRoute
}

const AuthenticatedAppShipmentsShipmentIdRouteWithChildren = AuthenticatedAppShipmentsShipmentIdRoute._addFileChildren(AuthenticatedAppShipmentsShipmentIdRouteChildren)



const AuthenticatedAppShipmentsRouteChildren = {
  AuthenticatedAppShipmentsShipmentIdRoute: AuthenticatedAppShipmentsShipmentIdRouteWithChildren,AuthenticatedAppShipmentsIndexRoute: AuthenticatedAppShipmentsIndexRoute
}

const AuthenticatedAppShipmentsRouteWithChildren = AuthenticatedAppShipmentsRoute._addFileChildren(AuthenticatedAppShipmentsRouteChildren)




const AuthenticatedAppSlottingRouteChildren = {
  AuthenticatedAppSlottingAbcRoute: AuthenticatedAppSlottingAbcRoute,AuthenticatedAppSlottingHeatmapRoute: AuthenticatedAppSlottingHeatmapRoute,AuthenticatedAppSlottingIndexRoute: AuthenticatedAppSlottingIndexRoute
}

const AuthenticatedAppSlottingRouteWithChildren = AuthenticatedAppSlottingRoute._addFileChildren(AuthenticatedAppSlottingRouteChildren)




const AuthenticatedAppTransfersRouteChildren = {
  AuthenticatedAppTransfersIdRoute: AuthenticatedAppTransfersIdRoute,AuthenticatedAppTransfersIndexRoute: AuthenticatedAppTransfersIndexRoute
}

const AuthenticatedAppTransfersRouteWithChildren = AuthenticatedAppTransfersRoute._addFileChildren(AuthenticatedAppTransfersRouteChildren)




const AuthenticatedAppWarehouseMapRouteChildren = {
  AuthenticatedAppWarehouseMapHeatmapRoute: AuthenticatedAppWarehouseMapHeatmapRoute,AuthenticatedAppWarehouseMapLocationsRoute: AuthenticatedAppWarehouseMapLocationsRoute,AuthenticatedAppWarehouseMapMovementRoute: AuthenticatedAppWarehouseMapMovementRoute,AuthenticatedAppWarehouseMapSlottingRoute: AuthenticatedAppWarehouseMapSlottingRoute,AuthenticatedAppWarehouseMapIndexRoute: AuthenticatedAppWarehouseMapIndexRoute
}

const AuthenticatedAppWarehouseMapRouteWithChildren = AuthenticatedAppWarehouseMapRoute._addFileChildren(AuthenticatedAppWarehouseMapRouteChildren)




const AuthenticatedAppPackOrderIdRouteChildren = {
  AuthenticatedAppPackOrderIdPackingSlipRoute: AuthenticatedAppPackOrderIdPackingSlipRoute
}

const AuthenticatedAppPackOrderIdRouteWithChildren = AuthenticatedAppPackOrderIdRoute._addFileChildren(AuthenticatedAppPackOrderIdRouteChildren)



const AuthenticatedAppRouteChildren = {
  AuthenticatedAppAdminRoute: AuthenticatedAppAdminRouteWithChildren,AuthenticatedAppChatRoute: AuthenticatedAppChatRoute,AuthenticatedAppComplianceRoute: AuthenticatedAppComplianceRouteWithChildren,AuthenticatedAppCycleCountsRoute: AuthenticatedAppCycleCountsRouteWithChildren,AuthenticatedAppDashboardRoute: AuthenticatedAppDashboardRoute,AuthenticatedAppDockRoute: AuthenticatedAppDockRoute,AuthenticatedAppExceptionsRoute: AuthenticatedAppExceptionsRoute,AuthenticatedAppForecastingRoute: AuthenticatedAppForecastingRouteWithChildren,AuthenticatedAppImplementationRoute: AuthenticatedAppImplementationRouteWithChildren,AuthenticatedAppImportsRoute: AuthenticatedAppImportsRoute,AuthenticatedAppInventoryRoute: AuthenticatedAppInventoryRouteWithChildren,AuthenticatedAppLabelsRoute: AuthenticatedAppLabelsRoute,AuthenticatedAppLaborRoute: AuthenticatedAppLaborRouteWithChildren,AuthenticatedAppOnboardingRoute: AuthenticatedAppOnboardingRoute,AuthenticatedAppOperationsRoute: AuthenticatedAppOperationsRouteWithChildren,AuthenticatedAppOrdersRoute: AuthenticatedAppOrdersRouteWithChildren,AuthenticatedAppPickRoute: AuthenticatedAppPickRouteWithChildren,AuthenticatedAppPlaybookRoute: AuthenticatedAppPlaybookRouteWithChildren,AuthenticatedAppPoliciesRoute: AuthenticatedAppPoliciesRouteWithChildren,AuthenticatedAppPutawayRoute: AuthenticatedAppPutawayRoute,AuthenticatedAppQualityIntelligenceRoute: AuthenticatedAppQualityIntelligenceRoute,AuthenticatedAppReceivingRoute: AuthenticatedAppReceivingRouteWithChildren,AuthenticatedAppReportsRoute: AuthenticatedAppReportsRouteWithChildren,AuthenticatedAppReturnsRoute: AuthenticatedAppReturnsRoute,AuthenticatedAppReturnsCreditsRoute: AuthenticatedAppReturnsCreditsRoute,AuthenticatedAppReturnsDispositionRoute: AuthenticatedAppReturnsDispositionRoute,AuthenticatedAppReturnsReceivingRoute: AuthenticatedAppReturnsReceivingRoute,AuthenticatedAppReturnsRefurbRoute: AuthenticatedAppReturnsRefurbRoute,AuthenticatedAppReturnsRulesRoute: AuthenticatedAppReturnsRulesRoute,AuthenticatedAppRfRoute: AuthenticatedAppRfRouteWithChildren,AuthenticatedAppScanRoute: AuthenticatedAppScanRoute,AuthenticatedAppShipmentsRoute: AuthenticatedAppShipmentsRouteWithChildren,AuthenticatedAppSlottingRoute: AuthenticatedAppSlottingRouteWithChildren,AuthenticatedAppSuppliersRoute: AuthenticatedAppSuppliersRoute,AuthenticatedAppTasksRoute: AuthenticatedAppTasksRoute,AuthenticatedAppTransfersRoute: AuthenticatedAppTransfersRouteWithChildren,AuthenticatedAppWarehouseMapRoute: AuthenticatedAppWarehouseMapRouteWithChildren,AuthenticatedAppYardRoute: AuthenticatedAppYardRoute,AuthenticatedAppBillingAnomaliesRoute: AuthenticatedAppBillingAnomaliesRoute,AuthenticatedAppBillingProfitabilityRoute: AuthenticatedAppBillingProfitabilityRoute,AuthenticatedAppBillingRulesRoute: AuthenticatedAppBillingRulesRoute,AuthenticatedAppPackOrderIdRoute: AuthenticatedAppPackOrderIdRouteWithChildren,AuthenticatedAppPackBatchRoute: AuthenticatedAppPackBatchRoute,AuthenticatedAppPackBulkRoute: AuthenticatedAppPackBulkRoute,AuthenticatedAppSettingsApiKeysRoute: AuthenticatedAppSettingsApiKeysRoute,AuthenticatedAppSettingsAuditLogRoute: AuthenticatedAppSettingsAuditLogRoute,AuthenticatedAppSettingsComplianceRoute: AuthenticatedAppSettingsComplianceRoute,AuthenticatedAppSettingsDataOwnershipRoute: AuthenticatedAppSettingsDataOwnershipRoute,AuthenticatedAppSettingsIncidentsRoute: AuthenticatedAppSettingsIncidentsRoute,AuthenticatedAppSettingsNotificationsRoute: AuthenticatedAppSettingsNotificationsRoute,AuthenticatedAppSettingsOnCallRoute: AuthenticatedAppSettingsOnCallRoute,AuthenticatedAppSettingsRetentionRoute: AuthenticatedAppSettingsRetentionRoute,AuthenticatedAppSettingsScimRoute: AuthenticatedAppSettingsScimRoute,AuthenticatedAppSettingsShipmentIssuesRoute: AuthenticatedAppSettingsShipmentIssuesRoute,AuthenticatedAppSettingsSsoRoute: AuthenticatedAppSettingsSsoRoute,AuthenticatedAppSettingsStatusRoute: AuthenticatedAppSettingsStatusRoute,AuthenticatedAppSettingsStatusSubscribersRoute: AuthenticatedAppSettingsStatusSubscribersRoute,AuthenticatedAppSettingsWebhooksRoute: AuthenticatedAppSettingsWebhooksRoute,AuthenticatedAppTraceCaptureRoute: AuthenticatedAppTraceCaptureRoute,AuthenticatedAppTraceabilityRefRoute: AuthenticatedAppTraceabilityRefRoute,AuthenticatedAppBillingIndexRoute: AuthenticatedAppBillingIndexRoute,AuthenticatedAppBolsIndexRoute: AuthenticatedAppBolsIndexRoute,AuthenticatedAppManifestsIndexRoute: AuthenticatedAppManifestsIndexRoute,AuthenticatedAppPackIndexRoute: AuthenticatedAppPackIndexRoute,AuthenticatedAppBillingInvoiceIdPrintRoute: AuthenticatedAppBillingInvoiceIdPrintRoute,AuthenticatedAppBillingCustomersCustomerIdRoute: AuthenticatedAppBillingCustomersCustomerIdRoute,AuthenticatedAppManifestsManifestIdPrintRoute: AuthenticatedAppManifestsManifestIdPrintRoute
}

const AuthenticatedAppRouteWithChildren = AuthenticatedAppRoute._addFileChildren(AuthenticatedAppRouteChildren)




const AuthenticatedPortalInboundRouteChildren = {
  AuthenticatedPortalInboundAsnIdRoute: AuthenticatedPortalInboundAsnIdRoute
}

const AuthenticatedPortalInboundRouteWithChildren = AuthenticatedPortalInboundRoute._addFileChildren(AuthenticatedPortalInboundRouteChildren)




const AuthenticatedPortalOrdersRouteChildren = {
  AuthenticatedPortalOrdersOrderIdRoute: AuthenticatedPortalOrdersOrderIdRoute,AuthenticatedPortalOrdersNewRoute: AuthenticatedPortalOrdersNewRoute
}

const AuthenticatedPortalOrdersRouteWithChildren = AuthenticatedPortalOrdersRoute._addFileChildren(AuthenticatedPortalOrdersRouteChildren)




const AuthenticatedPortalReportsRouteChildren = {
  AuthenticatedPortalReportsReportKeyRoute: AuthenticatedPortalReportsReportKeyRoute,AuthenticatedPortalReportsHistoryRoute: AuthenticatedPortalReportsHistoryRoute,AuthenticatedPortalReportsSubscriptionsRoute: AuthenticatedPortalReportsSubscriptionsRoute,AuthenticatedPortalReportsIndexRoute: AuthenticatedPortalReportsIndexRoute
}

const AuthenticatedPortalReportsRouteWithChildren = AuthenticatedPortalReportsRoute._addFileChildren(AuthenticatedPortalReportsRouteChildren)




const AuthenticatedPortalRmasRouteChildren = {
  AuthenticatedPortalRmasRmaIdRoute: AuthenticatedPortalRmasRmaIdRoute
}

const AuthenticatedPortalRmasRouteWithChildren = AuthenticatedPortalRmasRoute._addFileChildren(AuthenticatedPortalRmasRouteChildren)



const AuthenticatedPortalRouteChildren = {
  AuthenticatedPortalChatRoute: AuthenticatedPortalChatRoute,AuthenticatedPortalCreditsRoute: AuthenticatedPortalCreditsRoute,AuthenticatedPortalDashboardRoute: AuthenticatedPortalDashboardRoute,AuthenticatedPortalInboundRoute: AuthenticatedPortalInboundRouteWithChildren,AuthenticatedPortalInventoryRoute: AuthenticatedPortalInventoryRoute,AuthenticatedPortalInvoicesRoute: AuthenticatedPortalInvoicesRoute,AuthenticatedPortalOrdersRoute: AuthenticatedPortalOrdersRouteWithChildren,AuthenticatedPortalProfitabilityRoute: AuthenticatedPortalProfitabilityRoute,AuthenticatedPortalReportsRoute: AuthenticatedPortalReportsRouteWithChildren,AuthenticatedPortalRmasRoute: AuthenticatedPortalRmasRouteWithChildren,AuthenticatedPortalSettingsRoute: AuthenticatedPortalSettingsRoute,AuthenticatedPortalSlaRoute: AuthenticatedPortalSlaRoute,AuthenticatedPortalWorkspaceRoute: AuthenticatedPortalWorkspaceRoute
}

const AuthenticatedPortalRouteWithChildren = AuthenticatedPortalRoute._addFileChildren(AuthenticatedPortalRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAppRoute: AuthenticatedAppRouteWithChildren,AuthenticatedPortalRoute: AuthenticatedPortalRouteWithChildren,AuthenticatedScoreboardRoute: AuthenticatedScoreboardRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedSetupRoute: AuthenticatedSetupRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,NoAccessRoute: NoAccessRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,StatusRoute: StatusRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)